<template>
  <div class="broadcast">
     <div class="outer-container">
        <div class="inner-container" >
    <div class="content_box" @click="maskHidden">
      <div class="details-top-right">
        <div class="details-top-right-top" v-if="broadcastingData.user">
          <div class="details-top-right-left">
            <img @click="zhibojianAnchor(broadcastingData.user.uid)" :src="broadcastingData.user.avatar" alt="" />
          </div>
          <div class="details-top-right-center">
            <div class="details-top-right-center-top">
              <div class="title useall" @click="zhibojianAnchor(broadcastingData.user.uid)">
                {{ broadcastingData.user.nickname }}
              </div>
            </div>
            <div class="roomId">
              <div class="id_name useall">龙珠号:{{ longzhuhao }}</div>
              <div class="roomId_item">
                <div class="item">
                  <img src="https://oss.ansongqiubo.com/assets/roomlive/icon_guangzong@2x.png" alt="" />
                  <span>&nbsp;{{ broadcastingData.online?broadcastingData.online.count:0 }}</span>
                </div>
                <div class="item">
                  <img src="https://oss.ansongqiubo.com/assets/roomlive/icon_redu@2x.png" alt="" />
                  <span>&nbsp;{{ broadcastingData.room?broadcastingData.room.heatValue:0 }}</span>
                </div>
                <div @click="Jubao(broadcastingData.user.uid)" class="item">
                  <img src="/static/room/jubao.png" alt="" />
                  <span>举报</span>
                </div>
                <div class="item">
                  <img class="fenxiangclass" src="/static/room/shareroom.png" alt="" />
                  <span class="fenxiangclass" @click="Fenxiang">分享</span>
                  <!-- 分享复制地址 -->
                  <div class="fenxiangclass_box" v-show="fenxiang">
                    <div contenteditable="true" class="url_name myfont1">
                      {{ dizhi }}
                    </div>
                    <div class="tag-read" :data-clipboard-text="dizhi" @click="copys">
                      复制链接
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="details-top-right-right" v-if="useridRommid">
            <div class="care_user" v-show="weiguanzhuZhubo" @click="guanzhuzhuobo">
              关注 +
            </div>
            <div class="agree_user" v-show="yiguanzhuZhubo" @click="quguanzhuobo">
              <img src="https://oss.ansongqiubo.com/assets/roomlive/icon_dui@2x.png" alt="" srcset="" />
              已关注
            </div>
          </div>
        </div>
        <!-- 切换动画直播 -->
        <div class="lzVideoAnimalChange" v-if="animationUrl || matchId">
          <div @click="changePlay(1)" class="tabsName" :class="activeVideo==2?'activeVideo':''">
            <img style="width: 24px;height: 24px;margin-right: 4px;"
              :src="activeVideo==2?'https://oss.ansongqiubo.com/static/scope/room/lives1.png':'https://oss.ansongqiubo.com/static/scope/room/lives2.png'"
              alt="" srcset="">
            视频直播
          </div>
          <div @click="changePlay(2)" class="tabsName" :class="activeVideo==1?'activeVideo':''">
            <img style="width: 24px;height: 24px;margin-right: 4px;"
              :src="activeVideo==1?'https://oss.ansongqiubo.com/static/scope/room/animal1.png':'https://oss.ansongqiubo.com/static/scope/room/animal2.png'"
              alt="" srcset="">
            动画直播
          </div>
        </div>
        <!-- 直播间 -->
        <div class="details-top-right-center2">
         <!-- <ali-player @ready='playReady' :class="activeVideo ==2?'hiddens':''" v-if="source" ref="player"
            @play="play($event)" @pause="pause($event)" @liveStreamStop="liveStreamStop($event)" :islogin='sendMessage'
            :autoplay="true" :isLive="isLive" :rePlay="false" @changeSwitch='changeSwitch'
            @requestFullScreen="requestFullScreen($event)" @cancelFullScreen="cancelFullScreen"
            @changeDanmu='changeDanmu' @switchsrc='switchsrc' :videoSrc='videoSrc' :sourceList='sourceList'
            showBuffer="true" showBarTime="5000" format="m3u8" :source="source">
          </ali-player> -->
          <ali-player  :class="activeVideo ==2?'hiddens':''"  ref="player" v-if="source"
            @liveStreamStop="liveStreamStop($event)" :autoplay="true"  :rePlay="false"
            showBuffer="true" showBarTime="5000" @changeHD='switchsrc' @changeDM='changeDanmu' format="flv" :source="source">
          </ali-player>
          <!-- 动画 -->
          <div v-if="activeVideo ==2 && animationUrl">
            <iframe class="setiframe" :src="animationUrl" frameborder="0"></iframe>
          </div>
          <!-- 置顶包 -->
          <div class="Toppacket"  v-if="Twitterlist">
            <el-popover placement="bottom-start" popper-class="changePopoverOpenToppack" trigger="hover">
              <topPack @change = 'changePack'></topPack>
              <div class="giftImg" slot="reference">
                 <img class="myTopImg" src="@/assets/img/pack.png" alt="" srcset="">
              </div>
            </el-popover>
          </div>
          <!-- 弹幕 -->
          <div v-if="barrageIsShow && barrageList.length > 0" >
            <vue-baberrage :isShow="barrageIsShow" ref="baberrage" :barrageList="barrageList" :loop="barrageLoop"
              :maxWordCount="maxWordCount" :throttleGap="throttleGap" :boxHeight="boxHeight"
              :messageHeight="messageHeight" :lanesCount="lanesCount">
            </vue-baberrage>
          </div>
          <!-- 结束直播提示 -->
          <div v-show="OverLiveAtreaming" style="
              top: 0;
              position: absolute;
              width: 100%;
             height: 100%;
              z-index: 29;
              background: black;
              display: flex;
              align-items: center;
              justify-content: center;
            ">
            <div style="width: 70%; height: 65%; margin: 0 auto; background: black">
              <div style="width: 100%; display: flex; align-items: center">
                <div style="
                    width: 6px;
                    height: 30px;
                    background: #721edc;
                    border-radius: 100px;
                    margin-right: 15px;
                  "></div>
                <span style="font-size: 28px; color: #ffffff">相关内容</span>
              </div>
              <div style="
                  margin: 20px 0;
                  display: flex;
                  flex-wrap: wrap;
                  width: 100%;
                  height: calc(100% - 240px);
                ">
                <div style="
                    margin-left: 10px;
                    margin-top: 10px;
                    width: calc(33% - 10px);
                    height: calc(50% - 10px);
                    overflow: hidden;
                    border-radius: 6px;
                  ">
                </div>
              </div>
              <div style="width: 100%; text-align: center">
                <span style="font-size: 22px; color: #ffffff">主播下播了，去看看别的主播吧～</span>
              </div>
            </div>
          </div>
          <!-- 神龙礼物- 其他飘窗礼物 -->
          <!--  -->
          <div class="allSceengift" :class="piaochuangclass"
            @click="shenlongRouter(shenlongData.message.targetUser.uid)" v-if="shenlongData.message">
            <img v-if="shenlongData.message.type == ''" class="huojian" src="/static/room/shenlong.png" alt=""
              srcset="">
            <img v-if="shenlongData.message.type == 'rocket'" class="huojian" src="/static/room/huojian.png" alt=""
              srcset="">
            <img v-if="shenlongData.message.type == 'lakeCastle'" class="huojian" src="/static/room/hupanchengbao.png"
              alt="" srcset="">
            <img v-if="shenlongData.message.type == 'ship'" class="huojian" src="/static/room/youlun.png" alt=""
              srcset="">
            <img v-if="shenlongData.message.type == 'dreamCastle'" class="huojian"
              src="/static/room/menghuanchengbao.png" alt="" srcset="">

            <!-- 穿云箭 -->
            <img v-if="shenlongData.message.type == 'oven'" class="huojian myzhuyugift"
              src="/static/room/chuanyunjian.png" alt="" srcset="">
            <!-- 海鲸之梦 -->
            <img v-if="shenlongData.message.type == 'sea_whale'" class="huojian myzhuyugift"
              src="/static/room/haijingzhimeng.png" alt="" srcset="">
            <div class="myGiftData" v-if="shenlongData.message.type != ''">
              <img :src="shenlongData.message.gift.msgIcon" alt="" srcset="">
              <div class="userSendName">
                <span class="myfont"
                  style="width:90px;text-align:center;">{{ shenlongData.message.currentUser.nickname }}</span>在<span
                  class="myfont"
                  style="width: 90px;text-align:center;color: #721EDC;">{{ shenlongData.message.targetUser.nickname }}</span>直播间里刷了<span
                  style="text-align:center;">{{ shenlongData.message.gift.giftName}}</span>，快来围观吧！
              </div>
            </div>
            <div class="myGiftData" v-else>
              <img :src="shenlongData.message.gift.msgIcon" alt="" srcset="">
              <div class="userSendName">
                <span class="myfont"
                  style="width:86px;text-align:center;">{{ shenlongData.message.currentUser.nickname }}</span>在<span
                  class="myfont"
                  style="width:80px;text-align:center;color: #721EDC;">{{ shenlongData.message.targetUser.nickname }}</span>直播间里刷了<span>{{ shenlongData.message.gift.giftName}}</span>
                <img style="width: 64px;height: auto;" src="https://oss.ansongqiubo.com/assets/shenlongWeiguan.png"
                  alt="" srcset="">
              </div>
            </div>
          </div>
          <!-- 红包 -->
          <div class="big_packet" @click="openRedPackets" v-if="isShowpacket == 1">
            <img src="https://oss.ansongqiubo.com/assets/roomlive/redpacket.png" alt="" srcset="" />
          </div>
          <!-- 红包倒计时 -->
          <!-- <div class="timePackets" @click.stop="showRedPackets" v-if="Mypackets.length > 0">
            <div class="packets_item " :class="currentpacket.remainTime>0?'shouhutime':''">
              <img src="https://oss.ansongqiubo.com/assets/roomlive/xiaohongbao.png" alt="" />
              <div class="my_times">{{currentpacket.remainTime > 0?lasttimes:'点击开抢'}}</div>
            </div>
          </div> -->
          <!-- 主播直播间封停倒计时提示 -->
          <div class="closeVideLives" v-if="closeVideLives">
              主播直播间涉嫌{{FifmuteData(closeVideLiveData.reason)}}
              <div  v-if="closeVideLiveData.expireTime > 0">
               已被封停，离解封还剩 <span>{{closeVideLiveData.strtime}}</span>
              </div>
              <div v-else>
                已被<span>永久封停！</span>
              </div>
          </div>
          <!-- 红包结果 -->
          <div class="big_packet" v-if="isShowpacket == 2">
            <img src="https://oss.ansongqiubo.com/assets/roomlive/openhongbao.png" alt="" srcset="" />
            <div class="no_money_price" v-if="robPacket.money==0">
              <div class="error_name">很抱歉</div>
              <div class="emits">您没有抢到红包</div>
            </div>
            <div class="no_money_price" v-if="packet_msg">
              <div class="error_name">系统提示</div>
              <div class="emits">{{packet_msg}}</div>
            </div>
            <div class="money_price" v-if="robPacket.money >0">
              <div class="error_name">恭喜你</div>
              <div class="emits">
                <span>抢到</span>
                <div class="span myfont1">{{broadcastingData.user.nickname}}</div>
                <span>的红包</span>
              </div>
              <div class="packet_price">
                <div class="number1">{{robPacket.money}}</div>
                <div class="txt1">龙币</div>
              </div>
              <div class="alerts">已到账金额</div>
            </div>
            <!-- 关闭红包 -->
            <div class="close_img" @click="closepackets">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFqADAAQAAAABAAAAFgAAAAAcITNaAAACTElEQVQ4Ee1Ty04iURCVbqB9kIzACn7CwMKYzIbVuCLOQvasICoJ6Ex8zgNHNKMS8NUL4A+IC2Fngkoyuwl8hBsIS8KKZ8+pCddUt8APKAm5datOnTpV1Xdq6v03nICJTyISibg7nc5H+O6y2WyXx8bZgUBAdjqdn2VZrqiq+ixwkjDobLfbCxaLJW8ymS5CoZCFx0bZRGq320/NZvNtt9td5BgdMQhLUJwAcB12Oh6PmzmY20OlpxDyBaQpt9td4HHdKEQAahNIOOj1eqrL5YqhQE/E6CRSh8NxBgFbEJLC2L5CiMYxOsUiAOA3qDhB4katVkv7fL4X5UPSJJGicDKXy70iJZ6RikWBcDh8gqXsgeAGrUbJX6/XUyCNwneeyWS2BdZ4ykYHv1er1QePxzNN6lqt1jz+n1AoBtIzdLXDsUZ7IjGBidzr9SqSJFHLS/1+/zdId41ExvvIGXMQFieBcI75FE3TJo6QsBMBw0Vdov0NLDOBE8KlfYziCjPfRNEBK6gzX7at8+KSz+flUql0jfmugfQY2/9OGCxUxqe4gyVCuLZp/MwEz8gZk9JGoyFIjzDT/6SUVKlUHgqFwgw9jGKxOI8d3Asyfr6aMZHimapoew0t/wLpD55ACjGGPXRBDySKx5SiPXAM2TrFwWBw2maz3UBNmEjxnf40JtC9XC5rfr//sdlszpJynB9wf4K/L/C6SoqirFit1hDUxMeRikRaHJTvAnuOnBhe6IqI0akjBujPYDBYRvuHHDTOFuTobhXK/47DvXH/P63F/IFTFwMxAAAAAElFTkSuQmCC"
                alt="">
            </div>
          </div>
          <!-- 礼物大小 -->
          <div ref="svgas" v-if="ShowSVGas" :class="changesvga?'showSvga':'hiddensvga'">
            <div id="svga" class="svgaBox"></div>
          </div>
          <!-- 主播发布推单 -->
          <div class="push_order_add" v-if="alert_add_order">
            <div class="order_headers">
              <div>发布推单</div>
              <div class="close_add_order"><img @click="alert_add_order = false" class="tracqCss"
                  style="position: absolute; top: 10px; right: 10px"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" /></div>
            </div>
            <div class="from_order">
              <div class="name_order">标题</div>
              <div class="input_order"> <input type="text" v-model="fromorder.title" placeholder="请输入推单标题"> </div>
            </div>
            <div class="from_order">
              <div class="name_order">分类</div>
              <div class="input_order">
                <div class="items_from_soft" @click="fromorder.matchType =1"
                  :class="fromorder.matchType ==1?'order_soft_active':''">足球</div>
                <div class="items_from_soft" @click="fromorder.matchType =2 "
                  :class="fromorder.matchType ==2?'order_soft_active':''">篮球</div>
              </div>
            </div>
            <div class="from_order">
              <div class="name_order">赛场</div>
              <div class="input_order">
                <div class="items_from_soft" @click="fromorder.matchStage =1"
                  :class="fromorder.matchStage ==1?'order_soft_active':''">赛前</div>
                <div class="items_from_soft" @click="fromorder.matchStage =2"
                  :class="fromorder.matchStage ==2?'order_soft_active':''">赛中</div>
              </div>
            </div>
            <div class="from_order">
              <div class="name_order">价格</div>
              <div class="input_order">
                <el-radio v-model="fromorder.free" :label="2">
                  自定义
                </el-radio>
                <div class="price_order">
                  <input type="text" :disabled="fromorder.free==1" maxlength="6" v-model="fromorder.amount"
                    placeholder="请输入价格">
                  <div>龙币</div>
                </div>
                <el-radio v-model="fromorder.free" :label="1" @change='chageRadio'>免费</el-radio>
              </div>
            </div>
            <div class="from_order" style="align-items: flex-start;margin-top: 26px;">
              <div class="name_order">方案</div>
              <div class="input_order_text">
                <textarea name="" id="" v-model="fromorder.content" placeholder="请输入方案" cols="30" rows="10"></textarea>
              </div>
            </div>
            <div class="btn_sumt">
              <span v-if="fromorder.content &&fromorder.title" class="btn_active" @click="pushData">发布</span>
              <span v-else>发布</span>
            </div>
            <div class="message_order_txt">*您所发布的推单内容必须健康合法，造成所有的不良后果和平台无关</div>
          </div>
          <!-- 推单详情 -->
          <div class="push_order_add" v-if="alert_order_details">
            <div class="order_headers">
              <div>推单详情</div>
              <div class="close_add_order">
                <img @click="alert_order_details = false" class="tracqCss"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" />
              </div>
            </div>
            <div class="order_box">
              <div class="tabs" :class="fanganContent.matchType==1?'hong':'lan'">
                {{fanganContent.matchType==1?'足球':'篮球'}}
              </div>
              <div class="order_title" style="flex: 2;text-align: left;">
                {{fanganContent.title}}
              </div>
              <div class="order_status" v-if="fanganContent.state ==1">
                <span>封单中</span>
              </div>
              <div class="order_status" v-if="fanganContent.state ==0">
                <span>未结单</span>
              </div>
              <div class="order_status" v-if="fanganContent.state ==3">
                <img v-if="fanganContent.extraData.accountResult==1" style="width: 30px;height: 30px;"
                  src="https://oss.ansongqiubo.com/assets/roomlive/order_zou.png" alt="" srcset="">
                <img v-if="fanganContent.extraData.accountResult==2" style="width: 30px;height: 30px;"
                  src="https://oss.ansongqiubo.com/assets/roomlive/order_hong.png" alt="" srcset="">
                <img v-if="fanganContent.extraData.accountResult==3" style="width: 30px;height: 30px;"
                  src="https://oss.ansongqiubo.com/assets/roomlive/order_ hei.png" alt="" srcset="">
              </div>
            </div>
            <div class="order_content_detail" v-if="fanganContent.content">
              {{fanganContent.content}}
            </div>
            <div class="order_Id">
              订单号：{{fanganContent.recommendNo}}
            </div>
            <div class="order_timePay">
              <div> {{fifTime(fanganContent.publishTime)}}</div>
              <div class="moneys">
                <div v-if="fanganContent.free == 1">免费方案</div>
                <div v-else>{{fanganContent.amount}} 龙币 </div>
              </div>
            </div>
            <div v-if="fanganContent.state !==3 && Twitterlist">
              <div class="btn_box_order" v-if="fanganContent.state ==1">
                <div class="order_btns" @click="openOrderdata(fanganContent)"
                  style="color: #fff;background-color:#721EDC ;">
                  解封
                </div>
              </div>
              <div class="btn_box_order" v-else>
                <div class="order_btns" @click="overOrderdata(true)">
                  封单
                </div>
                <div class="order_btns" @click="overOrderdata(false)" style="color: #fff;background-color:#721EDC ;">
                  结单
                </div>
              </div>
            </div>
            <div v-else class="user_bnt_close" @click="alert_order_details = false">
              <div>
                确定
              </div>
            </div>
          </div>
          <!--提示确认封单 -->
          <div class="mask_bg" v-if="alert_order_seal">
            <div class="sael_order">
              <div class="s_title">
                是否确认封单
              </div>
              <div class="s_btn">
                <span @click="alert_order_seal = false">
                  取消
                </span>
                <span @click="sealOrder" style="background: #721EDC;color: #fff;">
                  确定
                </span>
              </div>
            </div>
          </div>
          <!-- 粉丝团规则 -->
          <div class="push_order_add" @click.stop="" v-if="fansgrouprule">
            <div class="order_headers">
              <div>粉丝团规则</div>
              <div class="close_add_order"><img @click="fansgrouprule = false" class="tracqCss"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" /></div>
            </div>
            <iframe src="https://m.longzhu.com/h5/fanGroup.html" frameborder='0' allowTransparency="true"  style="border: none;" width="416px"
              height="400px"></iframe>
          </div>
          <!-- 购买推单 -->
          <div class="push_order_add" v-if="alert_order_buy">
            <div class="order_headers">
              <div>购买推单</div>
              <div class="close_add_order"><img @click="alert_order_buy = false" class="tracqCss"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" /></div>
            </div>
            <div class="user_order_header">
              <div class="orderUsername otest">
                <img :src="currentUserinfo.avatar" alt="" srcset="">
                <span>{{currentUserinfo.nickname}}</span>
              </div>
              <div class="otest">
                <span>
                  余额:{{money}}龙币
                </span>
              </div>
            </div>
            <div class="paymoneys">
              <div class="pname">{{fanganContent.title}}</div>
              <div class="pmoney">
                <div>支付金额</div>
                <div style="color: #FFC000;">
                  <span v-if="fanganContent.amount == 0">免费方案</span>
                  <span v-else>{{fanganContent.amount}} 龙币 </span>
                </div>



              </div>
            </div>
            <div class="ptitles">
              支付方式
            </div>
            <div class="peyorder">
              <span>余额支付</span>
              <img src="https://oss.ansongqiubo.com/assets/roomlive/weixin_pay.png" alt="" srcset="">
            </div>
            <div class="btnPay" @click="buyOrder(fanganContent.recommendId)">
              <span>购买</span>
            </div>
          </div>
          <!-- 结单 -->
          <div class="push_order_add" style="padding:22px 0 0;" v-if="alert_order_over">
            <div class="order_headers" style="padding: 0 22px;">
              <div>结单</div>
              <div class="close_add_order"><img @click="alert_order_over = false" class="tracqCss"
                  src="https://oss.ansongqiubo.com/Image/priceImage/guanbi.png" alt="" /></div>
            </div>
            <div class="ptitles" style="font-weight: 400;padding: 0 22px;">
              您发布的某某某推单的结果是：
            </div>
            <div class="order_status" style="padding: 0 22px;">
              <div class="statusImg" @click="checkOrderIndex = 1" :class="checkOrderIndex==1?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_hong.png" alt="" srcset="">
              </div>
              <div class="statusImg" @click="checkOrderIndex = 2" :class="checkOrderIndex==2?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_zou.png" alt="" srcset="">
              </div>
              <div class="statusImg" @click="checkOrderIndex = 3" :class="checkOrderIndex==3?'checkOrderdefault':''">
                <img src="https://oss.ansongqiubo.com/assets/roomlive/order_ hei.png" alt="" srcset="">
              </div>
            </div>
            <div class="source_button" style="border-top: 1px solid rgba(0, 0, 0, 0.1);margin-top: 38px;">
              <div class="source_cencal" @click="alert_order_over = false">
                取消
              </div>
              <div class="source_ok" style="color: #000;" @click="overorderStatus">
                确认
              </div>
            </div>
          </div>
          <!-- 足球-比赛结束提示 -->
          <div v-if="DialogScopeOver">
            <el-dialog :visible.sync="DialogScopeOver" :modal='false' :show-close='false' width="286px" top='45vh'
              custom-class='DialogScopeOver' center>
              <div slot="title" class="DialogTitle">温馨提示</div>
              <span class="contentVal">当前比赛已结束，如需继续直播请在开播处修改对应的比赛数据</span>
              <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="navtoUpdata()">去修改</el-button>
              </span>
            </el-dialog>
          </div>
        </div>
        <!-- 充值-送礼 -->
        <div class="details-top-right-bottom">
          <div class="details-top-right-bottom_box">
            <div class="details-top-right-bottom-left">
              <div class="toolsGift" v-if="sendMessage">
                <el-popover   @show='openreceivetask' placement="top-start" width="400" trigger="hover" popper-class="RooMpopTaskBox">
                	  <receivetask @openiframe='openiframe'  :autoload='true'  ref="receivetask"></receivetask>
                    <div slot="reference" >
                      <div class="toolsGiftitem">
                        <img class="baoxiang" src="/static/newcenter/baoxiang.png" alt="" srcset="">
                        <span v-if="$store.state.boxTimes && $store.state.boxTimes.type ==1">
                          {{$store.state.boxTimes.times}}
                        </span>
                        <span v-if="$store.state.boxTimes && $store.state.boxTimes.type ==2">
                          待领取
                        </span>
                        <span v-if="$store.state.boxTimes && $store.state.boxTimes.type ==3">
                          已完成
                        </span>
                      </div>
                    </div>
                </el-popover>
                <div class="toolsGiftitem" @click.stop="showRedPackets" v-if="Mypackets.length > 0">
                  <img class="hongbaos" src="/static/newcenter/packet.png" alt="" srcset="">
                  <span>
                    {{currentpacket.remainTime > 0?lasttimes:'点击开抢'}}
                  </span>
                </div>
                <div class="toolsGiftitem" @click.stop="getActives" >
                  <img class="actives" src="/static/newcenter/activeIcon.png" alt="" srcset="">
                  <span class="actives2">
                      活动中心
                  </span>
                </div>
                <el-popover  placement="top-start" width="350" trigger="hover" popper-class="AnchorTaskBox">
                	  <AnchorTask v-if="broadcastingData.user && broadcastingData.user.uid" :anchorId='broadcastingData.user.uid' :itemValue ='AnchorTaskList' ></AnchorTask>
                    <div slot="reference" >
                      <div class="toolsGiftitem" >
                        <img class="actives" src="@/assets/img/home/home_task.png" alt="" srcset="">
                        <span class="actives2" >
                            主播任务
                        </span>
                      </div>
                    </div>
                </el-popover>
              </div>
              <div class="toolsGift" v-else>
                <div class="toolsGiftitem" @click="denglu">
                  <img class="baoxiang" src="/static/newcenter/baoxiang.png" alt="" srcset="">
                  <span >
                      宝箱
                  </span>
                </div>
                <div class="toolsGiftitem" @click.stop="denglu" >
                  <img class="actives" src="/static/newcenter/activeIcon.png" alt="" srcset="">
                  <span class="actives2">
                      活动中心
                  </span>
                </div>
                <div class="toolsGiftitem" @click="denglu">
                  <img class="actives" src="@/assets/img/home/home_task.png" alt="" srcset="">
                  <span class="actives2" >
                      主播任务
                  </span>
                </div>
              </div>
             <div class="toolsGift" >

              </div>
            </div>
            <div class="gift">
              <div class="redpackets">
                <div class="packets_item ">
                  <div class="floatTopHover">
                    <img class="quickbg" src="/static/room/msg_gift.png" alt="" srcset="">
                    <div class="giftBox">
                      <div class="leftimgBox">
                        <img :src="quickgiftList.iconUrl" alt="" />
                      </div>
                      <div style="display: flex;flex-direction: column;align-items: flex-start;">
                        <div class="quickgiftname ">
                          {{ quickgiftList.name }}
                        </div>
                        <div class="mySums">
                          {{ quickgiftList.amount }} {{quickgiftList.currencyType ==1?'龙币':'贝壳'}}
                        </div>
                      </div>
                      <div @click="ZengsongLiwu(quickgiftList.id)" class="sendGift">
                        赠送
                      </div>
                    </div>
                  </div>
                  <img :src="quickgiftList.iconUrl" alt="" />
                </div>
              </div>
              <div class="lines"></div>
              <!-- 默认显示的礼物列表 -->
              <div class="redpackets" v-if="liwudata[0]">
                <div class="packets_item hiddenGifts" :class="liwudata[0].gifts.length - 5 <= index ?'activeitem':''"
                  v-if='index > 4 && index < 12' v-for="(item, index) in liwudata[0].gifts" :key="index">
                  <div class="floatTopHover">
                    <img class="quickbg" src="/static/room/msg_gift.png" alt="" srcset="">
                    <div class="giftBox">
                      <div class="leftimgBox">
                        <img :src="item.iconUrl" alt="" />
                      </div>
                      <div style="display: flex;flex-direction: column;align-items: flex-start;">
                        <div class="quickgiftname">
                          {{ item.name }}
                        </div>
                        <div class="mySums">
                          {{ item.amount }} {{item.currencyType ==1?'龙币':'贝壳'}}
                        </div>
                      </div>
                      <div @click="ZengsongLiwu(item.id)" class="sendGift">
                        赠送
                      </div>
                    </div>
                  </div>
                  <img :src="item.iconUrl" alt="" />
                </div>
              </div>
              <!-- 点击右边出现礼物列表 -->
              <div class="moreGift elementHove">
                <div @click.stop="Right(false)" class="btnMoreGift ">
                  <img :class="liwuLiabiao?'':'tranfrom180'" class="oldel" src="/static/newhome/xiala1.webp" alt="">
                  <img :class="liwuLiabiao?'':'tranfrom180'" class="newel" src="/static/newhome/xiala2.webp" alt="">
                 <!-- <img :class="liwuLiabiao?'':'tranfrom180'" style="margin-top: 20px" src="/static/room/btnMore.png"
                    alt="" /> -->
                </div>
                <div class="mygiftBao" v-if="liwuLiabiao">
                  <div class="MoreGiftBox" @click.stop="">
                    <div class="gift_Title">
                      <div class="giftitleItem" @click.stop="LiwufenleiIndex(index)" v-for="(item, index) in liwudata"
                        :key="index" :class="{ liwufenleicolor: liwufenleiindex == index }">
                        {{ item.categoryName }}
                        <div style="width: 16px; height: 2px; background: #721edc;margin-top: 6px;"
                          v-if="index == liwufenleiindex" v-show="haohualiwu"></div>
                      </div>
                    </div>
                    <!-- 豪华礼物 -->
                    <div @click.stop='' style="height: 144px;" class="redpackets" v-if="haohualiwu">
                      <div class="srollgiftBxo" v-for="(items, index) in liwudata" :key="index"
                        v-if="index == liwufenleiindex">
                        <div class="packets_item" v-for="(item, indexs) in items.gifts" :key="indexs">
                          <div class="floatTopHover">
                            <img class="quickbg" src="/static/room/msg_gift.png" alt="" srcset="">
                            <div class="giftBox">
                              <div class="leftimgBox">
                                <img :src="item.iconUrl" alt="" />
                              </div>
                              <div style="display: flex;flex-direction: column;align-items: flex-start;">
                                <div class="quickgiftname">
                                  {{ item.name }}
                                </div>
                                <div class="mySums">
                                  {{ item.amount }} {{item.currencyType ==1?'龙币':'贝壳'}}
                                </div>
                              </div>
                              <div  v-if='item.haveEquities == 0' style="opacity: .8;" @click="lanjieLiwu(item)" class="sendGift">
                                   <img style="width: 12px;height: 12px;margin:0 1px" src="/static/newroom/fanslock.png" alt="">
                                  赠送
                              </div>
                              <div  v-else @click="ZengsongLiwu(item.id)" class="sendGift">
                                赠送
                              </div>
                            </div>
                          </div>
                          <img :src="item.iconUrl" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="moneysBox">
          <div style="flex: 2;">
            <div class="myhotTimes" v-if="Twitterlist">
              <img src="@/assets/img/pack.png" alt="">
              <div class="hottimetxt">置顶包有效期：<span>{{timeackage.heatStartTime}}</span> 至 <span>{{timeackage.heatEndTime}}</span> </div>
            </div>
          </div>
          <div class="moneyitems">
            <img style="width: 20px; height: 20px"
              src="https://oss.ansongqiubo.com/Image/broadcastImage/longbi.png" alt="" />
            <span
              style="margin:0 5px">{{ $store.state.userMoneyData?$store.state.userMoneyData.dragonCoin:0 }}</span>
          </div>
          <div class="moneyitems">
             <img style="width: 20px; height: 20px" src="/static/newcenter/beike.png"  alt="" />
             <span  style="margin-left: 5px">{{  $store.state.userMoneyData?$store.state.userMoneyData.shellCoin:0 }}</span>
          </div>
          <div class="tbnpay_moneys" @click="$emit('save')">
            充值
          </div>
        </div>
        <!-- 比分 -->
        <div class="home-right myvideo_list" v-if="a.roomid && matchId">
          <roomScope ref="roomScope" @change='scopeAnimal' :matchId='matchId'></roomScope>
        </div>
        <!-- 直播推荐 -->
        <div class="home-right myvideo_list">
          <div class="centerData" v-if="shouyeData.list && shouyeData.list.length > 0">
            <div class="home-right-center">
              <div class="title_img">
                <img src="https://oss.ansongqiubo.com/assets/home/icon_zhibotuijian@2x.png" alt="" />
              </div>
              <div class="title">直播推荐</div>
              <div class="moredata">
                <div class="title" @click="navmore">更多直播</div>
                <div class="more_icon">
                  <img src="https://oss.ansongqiubo.com/assets/home/icon_jt_R@2x.png" alt="" srcset="" />
                </div>
              </div>
            </div>
            <!-- 底部视频列表 -->
            <div class="mylista video_bottom">
              <div class="home-right-bottom">
                <div class="setWidth" v-for="(item, index) in shouyeData.list" :key="index" >
                  <liveItem @login='denglu' :liveDetailitems='item'></liveItem>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    <!-- 聊天推单面板 -->
    <div class="broadcast-right">
      <div class="broadcast-right-bottom">
        <noticeItem :notice="noticelsit"></noticeItem>
        <!-- 聊天界面 -->
         <!-- <div class="chat">
            <chatlabel :roomId='a.roomid' :noticeTxt='roomNoticetext' :historyMsg='message1' :newmessage='message' :roomInfoData='broadcastingData'></chatlabel>
         </div> -->

         <!-- 聊天界面 -->
         <div  class="chat itempaddings">
           <div class="broadcast-right-bottom-message chat_box">
             <!-- 用户聊天 -->
             <div class="broadcast-right-bottom-message-message">
               <div class="user_chat">
                 <span class="user_name"> 系统提示 </span>
                 <span class="user_content" style="color: #666666;">
                   {{roomNoticetext}}
                 </span>
               </div>
             </div>
             <!-- 直播间历史聊天消息 -->
             <div class="broadcast-right-bottom-message-message"  @click="TraCQ(item.currentUser.uid)" v-for="(item, index) in message1"
               :key="'info2-' + index">
               <div v-if="item.currentUser"
                 :class="{ name: nameindex == index }"  class="user_chat">
                 <!-- 用户标签 -->
                 <div class="labelBox" v-if="
                       item &&
                       item.currentUser &&
                       item.currentUser.level
                     " >
                   <div  class="user_newGreeds_bigs"   v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.currentUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.currentUser && item.currentUser.role >= 2">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.currentUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.currentUser.role  == 4" />
                   </div>
                 <!--  <div  class="user_newGreeds" v-else>
                     <img :src="'/static/newhome/b' +  fifLabelName( item.currentUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div  class="new_fansIcon"  v-if="item.fans && item.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.fans.level)+'.webp'" alt="">
                     <span>{{item.fans.name?item.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级 -->
                   <div class="user_newGreeds" v-if="item && item.currentUser && item.currentUser.level">
                      <img :src="
                          '/static/newhome/l' + fifGreed( item.currentUser.level) +     '.webp'
                        " alt="" />
                   </div>
                 </div>

                 <span class="user_name" style="color: #2C62CF;" v-if="item.currentUser && item.currentUser.nickname">
                   {{ item.currentUser.nickname }}:
                 </span>
                 <span class="user_content" v-if="item.message && item.message.content ">
                   {{ item.message.content }}
                 </span>
                 <!-- 系统提示 -->
                 <span class="user_content" style="color: #999;" v-if="item.message.systemtext">
                   <span class="user_name" style="color: #2C62CF;">系统提示</span> {{ item.message.systemtext }}
                 </span>
               </div>
             </div>

             <div class="broadcast-right-bottom-message-message" v-for="(item, index) in message" :key="index">
               <!-- 用户发送弹幕 -->
               <div v-if="item.messageType === 10003">
                 <div  @mouseenter="NameYiru(index)" @mouseleave="NameYichu(index)"
                   :class="{ name: nameindex == index }" @click="TraCQ(item.message.currentUser.uid)">
                   <!-- 用户标签 -->
                   <div class="labelBox" v-if="
                       item.message &&
                       item.message.currentUser &&
                       item.message.currentUser.level
                     " >
                     <!-- 哪吒 -->
                     <div  class="user_newGreeds_bigs"   v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.currentUser.uid">
                       <img src="/static/newhome/nezha.webp" alt="" />
                     </div>
                     <!-- 虾兵蟹将 -->
                     <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.currentUser && item.message.currentUser.role > 0">
                       <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.currentUser.role  == 2" />
                       <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.currentUser.role  == 4" />
                     </div>
                     <!-- 标签 -->
                    <!-- <div  class="user_newGreeds"  v-else-if=" item.message.fans && item.message.fans.level == 0 ">
                       <img :src=" '/static/newhome/b' +  fifLabelName( item.message.currentUser.level).bg + '.webp' " alt="" />
                     </div> -->
                     <!-- 粉丝团标签 -->
                     <div  class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                       <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                       <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                     </div>
                     <!-- 用户等级 -->
                     <div class="user_newGreeds" v-if="item.message.currentUser.level">
                        <img :src="
                            '/static/newhome/l' +
                            fifGreed( item.message.currentUser.level) +
                              '.webp'
                          " alt="" />
                     </div>
                   </div>

                   <span class="user_name" style="color: #2C62CF;">
                     {{ item.message.currentUser.nickname }}</span>:
                   <span class="user_content" v-if="item.message.message" :style="{'color':'' + item.message.fans.color}">
                     {{ item.message.message.content }}
                   </span>
                    <!-- :class=" a.userid == item.message.currentUser.uid?'room_userself':''" -->
                 </div>
                 <!-- item.message.currentUser.level -->
               </div>
               <!-- 用户进入房间 -->
               <div v-if="item.messageType === 10001" @click="TraCQ(item.message.currentUser.uid)">
                 <div class="labelBox" v-if="
                     item.message &&
                     item.message.currentUser &&
                     item.message.currentUser.level
                   " >
                   <!-- 哪吒 -->
                   <div  class="user_newGreeds_bigs"   v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.currentUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <!-- 虾兵蟹将 -->
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.currentUser && item.message.currentUser.role > 0">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.currentUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.currentUser.role  == 4" />
                   </div>
                   <!-- 标签 -->
                  <!-- <div v-else-if="item.message.fans && item.message.fans.level == 0 " class="user_newGreeds" >
                     <img :src=" '/static/newhome/b' +  fifLabelName( item.message.currentUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                     <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级标签 -->
                   <div class="user_newGreeds" v-if="item.message.currentUser.level">
                      <img :src="
                          '/static/newhome/l' +
                            fifGreed( item.message.currentUser.level) +
                            '.webp'
                        " alt="" />
                   </div>
                 </div>
                 <span class="user_name" style="color: #2C62CF;">
                   {{ item.message.currentUser.nickname }}
                 </span>
                 <span class="user_content" style="color: #999999"> 欢迎进入直播间</span>
               </div>
               <!-- 关注主播 -->
               <div v-if="item.messageType === 10013" @click="TraCQ(item.message.currentUser.uid)">
                 <div class="labelBox" v-if="
                     item.message &&
                     item.message.currentUser &&
                     item.message.currentUser.level
                   " >
                   <div  class="user_newGreeds_bigs"   v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.currentUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.currentUser && item.message.currentUser.role > 0">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.currentUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.currentUser.role  == 4" />
                   </div>
                 <!--  <div v-else class="user_newGreeds"  >
                     <img :src=" '/static/newhome/b' +  fifLabelName( item.message.currentUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div  class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                     <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级 -->
                   <div class="user_newGreeds" v-if="item.message.currentUser.level">
                      <img :src="
                          '/static/newhome/l' +
                           fifGreed( item.message.currentUser.level) +
                            '.webp'
                        " alt="" />
                   </div>
                 </div>
                 <span class="user_name" style="color: #2C62CF;">
                   {{ item.message.currentUser.nickname }}
                 </span>
                 <span class="user_content" style="color: #999">
                   关注了主播</span>
               </div>
               <!-- 用户送礼消息 -->
               <div class="user_liwu" v-if="item.messageType === 10004" @click="TraCQ(item.message.currentUser.uid)">
                 <div class="labelBox" v-if="
                     item.message &&
                     item.message.currentUser &&
                     item.message.currentUser.level
                   " >
                   <div  class="user_newGreeds_bigs"   v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.currentUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.currentUser && item.message.currentUser.role > 0">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.currentUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.currentUser.role  == 4" />
                   </div>
                  <!-- <div v-else class="user_newGreeds"  >
                     <img :src=" '/static/newhome/b' +  fifLabelName( item.message.currentUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div  class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                     <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级 -->
                   <div class="user_newGreeds" v-if="item.message.currentUser.level">
                      <img :src="
                          '/static/newhome/l' +
                           fifGreed( item.message.currentUser.level) +
                            '.webp'
                        " alt="" />
                   </div>
                 </div>
                 <div class="user_name">{{ item.message.currentUser.nickname }}:</div>
                 <div class="user_content_liwu">送的&nbsp;<span>{{ item.message.gift.giftName }}</span></div>
                 <div style="margin-left:2px;display: inline;">
                   <img style="width:34px;height: 34px;vertical-align: bottom;" :src="item.message.gift.msgIcon"
                     alt="" />
                   <div style="color: rgba(255, 0, 0, 1.0); margin-left: 2px;display: inline;font-size: 14px;">x{{ item.message.gift.num }}
                   </div>
                 </div>
               </div>
               <!-- 禁言用户通知 -->
               <div class="user_chat" @click="TraCQ(item.message.targetUser.uid)" v-if="item.messageType === 10007">
                 <div class="labelBox" v-if="
                     item.message &&
                     item.message.targetUser &&
                     item.message.targetUser.level
                   " >
                   <div  class="user_newGreeds_bigs" v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.targetUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.targetUser && item.message.targetUser.role > 0">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.targetUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.targetUser.role  == 4" />
                   </div>
                  <!-- <div v-else class="user_newGreeds"  >
                     <img :src=" '/static/newhome/b' +  fifLabelName( item.message.targetUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div  class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                     <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级 -->
                   <div class="user_newGreeds" v-if="item.message.targetUser.level">
                      <img :src="
                          '/static/newhome/l' +
                           fifGreed( item.message.targetUser.level) +
                            '.webp'
                        " alt="" />
                   </div>
                 </div>
                 <span class="user_content">
                   <span class="user_name" style="color: #2C62CF;">
                     {{ item.message.targetUser.nickname }}
                   </span>
                   <span style="color: #999;"> 已被禁言</span>
                 </span>
               </div>
               <!-- 封禁用户通知 -->
               <div class="user_chat" @click="TraCQ(item.message.currentUser.uid)" v-if="item.messageType === 10010">
                 <div class="labelBox" v-if="
                     item.message &&
                     item.message.currentUser &&
                     item.message.currentUser.level
                   " >
                   <div  class="user_newGreeds_bigs" v-if="broadcastingData.user && broadcastingData.user.uid  ==  item.message.currentUser.uid">
                     <img src="/static/newhome/nezha.webp" alt="" />
                   </div>
                   <div  class="user_newGreeds_bigs"   v-else-if="item && item.message.currentUser && item.message.currentUser.role > 0">
                     <img src="/static/newhome/xiabing.webp" alt="" v-if="item.message.currentUser.role  == 2" />
                     <img src="/static/newhome/xiejiang.webp" alt="" v-if="item.message.currentUser.role  == 4" />
                   </div>
                   <!-- <div v-else class="user_newGreeds"  >
                     <img :src=" '/static/newhome/b' +  fifLabelName( item.message.currentUser.level).bg + '.webp' " alt="" />
                   </div> -->
                   <!-- 粉丝团标签 -->
                   <div  class="new_fansIcon"  v-if="item.message.fans && item.message.fans.level !=0">
                     <img :src="'/static/newhome/f'+(item.message.fans.level  )+'.webp'" alt="">
                     <span>{{item.message.fans.name?item.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                   </div>
                   <!-- 用户等级 -->
                   <div class="user_newGreeds" v-if="item.message.currentUser.level">
                      <img :src="
                          '/static/newhome/l' +
                           fifGreed( item.message.currentUser.level) +
                            '.webp'
                        " alt="" />
                   </div>
                 </div>
                 <span class="user_content" style="color: #2C62CF;">
                   {{ item.message.currentUser.nickname }} <span style="color: #999;"> 已被封禁</span>
                 </span>
               </div>

               <div class="user_chat" v-if="item.messageType === 10402">
                 <div style="display: inline-block;color: #2C62CF;cursor: pointer;"
                   @click="navOrderdetails(item.message)" class="user_content" v-if="item.message">
                   <span>系统提示</span><span style="color: #999;">
                     推单 <b>{{ item.message.title}}</b> 的结单
                   </span>
                   <span v-if="item.message.extraData.accountResult ==1" style="color: #ff0000;">
                     红
                   </span>
                   <span v-if="item.message.extraData.accountResult ==2" style="color: #ffaa00;">
                     走
                   </span>
                   <span v-if="item.message.extraData.accountResult ==3" style="color: #000000;">
                     黑
                   </span>

                 </div>
               </div>
               <!-- 加入粉丝团通知 -->
               <div class="user_chat" v-if="item.messageType === 10405">
                 <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message && item.message.type == 1">
                   恭喜 <span style="color: #2C62CF;"> {{ item.message.fansUserData.nickname}} </span> 成为粉丝团的第{{ item.message.fansNums}}位粉丝
                 </div>
                 <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message && item.message.type == 2">
                   恭喜 <span style="color: #2C62CF;"> {{ item.message.fansUserData.nickname}} </span> 重新点亮粉丝牌
                 </div>
               </div>
               <!-- 粉丝团升级通知 -->
               <div class="user_chat" v-if="item.messageType === 10406">
                 <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message">
                   恭喜<span style="color: #2C62CF;"> {{ item.message.fansUserData.nickname}} </span>粉丝团勋章升级
                 </div>
               </div>
               <!-- 系统提示 -->
               <div class="user_chat" v-if="item.messageType === 11111">
                 <div style="display: inline-block;color: #999999" class="user_content" v-if="item.message">
                   <!-- 系统提示 -->
                   <span class="user_name" style="color: #2C62CF;">系统提示</span> {{ item.message.content }}
                 </div>
               </div>
             </div>
           </div>
         </div>
        <!-- 加入粉丝团 -->
        <div class="addfanGroup" @click.stop="" v-if="addfansGroup">
          <div class="fans_header" v-if="fansdetailForUser.anchorUser">
            <div style=" height: 48px;width: 48px;">
              <img style="border-radius: 50%;" :src="fansdetailForUser.anchorUser.avatar" alt="" srcset="">
            </div>
            <div class="fans_title">
              <div class="ftitle">
                {{fansdetailForUser.fansClub.clubName?fansdetailForUser.fansClub.clubName:fansdetailForUser.anchorUser.nickname}}
                <img src="/static/newcenter/yiwen.png" @click="fansgrouprule = true" style="width:16px;height:16px" alt="" srcset="">
                <!-- <i class="el-icon-question myiconquestion" @click="fansgrouprule = true"></i> -->
              </div>
              <div class="countfansgroup">
                <span>团成员：{{fansdetailForUser.fansClubExtra.fansClubUserNum}}人</span><i
                  class="el-icon-arrow-right"></i>
                <!-- / v-if="fansdetailForUser.fansClubExtra.haveFansGroup == 1" -->
                <span>粉丝群：{{fansdetailForUser.fansClubExtra.fansGroupUserNum}}人<i
                    class="el-icon-arrow-right"></i></span>
              </div>
            </div>
          </div>
          <div class="fansquanyi">
            <div class="fname">
              粉丝团权益
            </div>
            <div class="quanList">
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/cuigeng.png" alt="" srcset="">
                <span>催更主播</span>
              </div>
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/gexingxunzhang.png" alt="" srcset="">
                <span>个性勋章</span>
              </div>
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/liwu.png" alt="" srcset="">
                <span>定制礼物</span>
              </div>
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/meirilibao.png" alt="" srcset="">
                <span>每日礼包</span>
              </div>
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/groupedit1.png" alt="" srcset="">
                <span>进场特效</span>
              </div>
              <div class="quanList-item">
                <img src="https://oss.ansongqiubo.com/static/room/zhibo.png" alt="" srcset="">
                <span>高清视频</span>
              </div>
            </div>
          </div>


          <!-- 主播 -->
          <div class="add_btns" v-if="this.fansState.fansUserState == 1 || a.userid == broadcastingData.user.uid" @click.stop="downloadApp">
            前往App互动
          </div>
          <div class="add_btns" v-else-if="this.fansState.fansUserState == -1 || a.userid == broadcastingData.user.uid" @click.stop="addjoinfans">
            重新点亮粉丝团（10龙币）
          </div>
          <div class="add_btns" v-else @click.stop="addjoinfans">
            加入粉丝团（10龙币）
          </div>
        </div>
        <!-- 输入框部分 -->
        <div v-if="liaotian" class="broadcast-right-bottom-tottom">
          <!-- 禁言提示-->
          <div class="user_nospeak" v-show="jinyan">
            <div style="font-size: 14px; color: red; line-height: 37px">
              {{ jinyanCentent }}
            </div>
          </div>

          <!-- 等级权限 -->
          <div class="user_tools itempaddings">
            <div class="leftBox">
              <!-- 进场和发言限时 -->
              <div class="jurisdiction" v-if="broadcastingData.user && broadcastingData.user.uid ==  a.userid">
                <img @click.stop="openSetting" src="https://oss.ansongqiubo.com/assets/roomlive/quan.png">
                <div @click.stop class="alert_quanbox" v-if="isOpenSetting">
                  <div class="greedTitle">
                    等级权限
                  </div>
                  <div class="select_into">
                    <div class="into_greed">
                      <span>进场等级</span>
                      <el-select v-model="selectDatainto.intoSelect" @change="setchangeinto1" placeholder="请选择">
                        <el-option v-for="item in selectOPtionlist.greed" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="into_greed">
                      <span>发言等级</span>
                      <el-select v-model="selectDatainto.saySelect" @change="setchangeinto2" placeholder="请选择">
                        <el-option v-for="item in selectOPtionlist.say" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 清空内容 -->
              <div class="closeGigt">
                <el-popover placement="top" popper-class="changePopoverOpenzimu" trigger="hover">
                  <!-- 快捷发言弹幕 -->
                  <roombarrage v-if="runbarrageListState" @sendMessage='barrageSendClick' @closeMessage='closeroomMessage'>
                  </roombarrage>
                  <div class="giftImg" slot="reference">
                    <s v-if='runbarrageListState'>
                       <!-- @click="closeroomMessage(true)" -->
                      <img class="showHover1" src="/static/newhome/danmu.webp"  alt="" />
                      <img class="showHover2"  src="/static/newhome/danmu1.webp"  alt="" />
                    </s>
                    <!-- @click="closeroomMessage(false)" -->
                    <img v-else  slot="reference" src="/static/newhome/danmu1.webp" alt="" />
                  </div>
                </el-popover>
              </div>
              <!-- 屏蔽礼物特效 -->
              <div class="closeGigt">
                <el-popover placement="top" width="100" popper-class="changePopovercloseGigt" trigger="hover" >
                  <div class="changePopovercloseGigtContent">
                    {{ShowSVGas?'点击屏蔽礼物特效':'点击恢复礼物特效'}}
                  </div>
                  <div slot="reference" class="giftImg">
                    <s v-if='ShowSVGas'>
                      <img  class="showHover1" src="/static/newhome/texiao.webp"  alt="" @click="changeSwitch(false)">
                      <img class="showHover2" src="/static/newhome/texiao1.webp"  alt="" @click="changeSwitch(false)">
                    </s>
                    <img src="/static/newhome/texiao1.webp" v-else alt="" @click="changeSwitch(true)">
                  </div>
                </el-popover>
              </div>
              <!-- 清空内容 -->
              <div class="closeGigt">
                <el-popover placement="top" popper-class="changePopovercloseGigt" width="100" trigger="hover"
                  >
                  <div class="changePopovercloseGigtContent">
                    点击清除聊天记录
                  </div>
                  <div slot="reference" class="giftImg">
                    <img  class="showHover1"  @click="clearmessage" src="/static/newhome/del.webp" alt="" />
                    <img  class="showHover2"  @click="clearmessage" src="/static/newhome/del1.webp" alt="" />
                  </div>
                </el-popover>
              </div>
            </div>
            <!-- 未登录提示消息数量 -->
            <!-- -->
            <div class='nologinMsg' v-if='!sendMessage && showNoMsg.state ' @click='denglu'>
                  <div class="noMsgNum">{{showNoMsg.num}}条新消息</div>
                  <img class="nologinNomsg2" src="@/assets/img/moredown.png" alt="" srcset="">
                  <img class="nologinNomsg" src="@/assets/img/nologin-nomsg.png" alt="" srcset="">
            </div>
            <div  v-if='!sendMessage && showNoMsg.state ' class="blockBop"></div>
          </div>
          <!-- 聊天输入框 -->
          <div v-if="sendMessage" class="broadcast-right-bottom-input">
            <div class="pushorders">
              <img @click.stop="addFans" src="/static/newhome/addfans.webp" alt="">
            </div>
            <!-- maxlength="40" show-word-limit -->
            <el-input resize="none" :autosize='false' @keyup.enter.native="send" type="textarea"
              placeholder="快来说些什么吧～" class="myinput" v-model="messageInput" ></el-input>
            <div v-if="sendmsgStatus" @click="send" class="btn_send">发送</div>
            <div v-else class="btn_send sendLoading">发送中 <i class="el-icon-loading"></i> </div>
          </div>
          <div v-else class="broadcast-right-bottom-input">
            <span @click="denglu" style="
                color: #721EDC;
                font-size: 14px;
                padding-left: 14px;
                margin-right: 2px;
                font-weight: 400;
                cursor: pointer;
              ">登录</span>
            <span style="color: #909090; font-size: 14px; font-weight: 400">发弹幕，来和主播互动！</span>
          </div>
        </div>
        <div v-else class="noshatmouse">
          <div  class="noshatmouseTxt">
            您涉嫌{{ FifmuteData(muteData.reason)}}已被禁言
          </div>
          <div class="noshatmouseTxt" v-if="muteData.expireTime > 0">解除禁言时间为：<span>{{muteData.strtime}}</span></div>
          <div class="noshatmouseTxt" v-else><span>永久禁言</span></span></div>
        </div>

        <!-- 礼物动画 -->
        <div v-if="liwuData.message" ref="liwudonghua2" class="liwuBox">
          <div class="userinfo_liwu">
            <div class="user_name">
              {{ liwuData.message.currentUser.nickname | GiftName }}
            </div>
            <div class="liwu_name">
              送的&nbsp;{{ liwuData.message.gift.giftName }}
            </div>
          </div>
          <div class="liwu_img">
            <img :src="liwuData.message.gift.msgIcon" alt="" />
          </div>
        </div>
        <!-- 用户进场 -->
        <div class="user_intoroom">
          <!--  -->
          <div ref="jinchangdonghua" class="user_intoItem">
            <div class="user_into_txt" v-if="xiaoxishuju.message">
              <div class="labelBox">
                <div class="user_newGreeds_bigs" style="margin-right: 2px;"
                  v-if="broadcastingData.user && broadcastingData.user.uid  ==   xiaoxishuju.message.currentUser.uid">
                  <img src="/static/newhome/nezha.webp" alt="" />
                </div>
                <div class="user_newGreeds_bigs"  style="margin-right: 2px;"  v-else-if="xiaoxishuju && xiaoxishuju.message.currentUser && xiaoxishuju.message.currentUser.role > 0">
                  <img src="/static/newhome/xiabing.webp" alt="" v-if="xiaoxishuju.message.currentUser.role  == 2" />
                  <img src="/static/newhome/xiejiang.webp" alt="" v-if="xiaoxishuju.message.currentUser.role  == 4" />
                </div>
               <!-- <div class="user_newGreeds"  v-else-if="xiaoxishuju.message.fans && xiaoxishuju.message.fans.level ==0">
                  <img
                    :src=" '/static/newhome/b' +  fifLabelName( xiaoxishuju.message.currentUser.level).bg + '.webp' "
                    alt="" />
                </div> -->
                <!-- 粉丝团标签 -->
                <div class="new_fansIcon" v-if="xiaoxishuju.message.fans && xiaoxishuju.message.fans.level !=0">
                  <img :src="'/static/newhome/f'+(xiaoxishuju.message.fans.level  )+'.webp'" alt="">
                  <span style="line-height: 12px;">{{xiaoxishuju.message.fans.name?xiaoxishuju.message.fans.name:broadcastingData.user.nickname.slice(0,3)}}</span>
                </div>
                <!-- 用户等级 -->
                <div class="user_newGreeds" style="margin:0 1px;" v-if="xiaoxishuju.message.currentUser.level">
                  <img :src="
                       '/static/newhome/l' +
                          fifGreed( xiaoxishuju.message.currentUser.level) +
                         '.webp'
                     " alt="" />
                </div>
              </div>
              {{
                xiaoxishuju.message.currentUser.nickname | LiveStreamingTitle
              }}
              &nbsp;&nbsp;来了
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 活动h5 -->
    <activedialog ref="myactivedialogs"></activedialog>
    <!-- 禁言封禁 -->
     <div>
       <roledialog @changeTxt='cardTA' @reportUser='cardReport' ref="myroledialog"></roledialog>
     </div>
     <!-- :itemIndex="itemIndex" :itemValue="itemValue" -->
    <!-- 房间封停 -->
    <div v-show="ban" style="
        color: #ffffff;
        z-index: 100;
        position: absolute;
        top: 50%;
        right: 50%;
        margin-right: -209px;
        margin-top: -81px;
        font-size: 18px;
        text-align: center;
        box-sizing: border-box;
        padding: 20px;
        height: 162px;
        border-radius: 6px;
        background-color: rgba(70, 70, 70, 1);
        width: 418px;
      ">
      <div>该房间已被封停</div>
      <div @click="Top" style="
          line-height: 34px;
          margin: 0 auto;
          font-size: 18px;
          text-align: center;
          height: 34px;
          border-radius: 17px;
          background-color: rgba(114, 30, 220, 1);
          margin-top: 30px;
          width: 132px;
        ">
        确定
      </div>
    </div>
    <Report  @jubao="jubaos" ref='MyReport' ></Report>
  </div>
</template>
<script>
  import Clipboard from "clipboard";
  import qs from "qs";
  import roledialog from '@/pages/components/lz_roledialog.vue'
  import activedialog from '@/pages/components/lz_activeDialog.vue'
  import moment from 'moment';
  import aliplayer from "../components/aliplayer.vue";
  import Report from "../component/Report.vue";
  import SVGA from "svgaplayerweb";
  import roomScope from '@/pages/components/lz_roomScope.vue';
  import roombarrage from '@/pages/components/lz_roombarrage.vue';
  import noticeItem from '@/pages/components/lz_noticeItem.vue'
  import liveItem from "../components/lz_liveItem.vue";
  import chatlabel from '@/pages/components/lz_chatlabel.vue';
  import receivetask from '@/pages/components/lz_receivetask.vue'
  import topPack from '@/pages/components/lz_topPack.vue'
  import AnchorTask from '@/components/AnchorTask.vue';
  import {
    envelope,
    snatchnvelope,
    roomJoin,
    setLevel,
    getLevel,
    barrageword,
    quickgift,
    roomnotice,
    roomInfo,
    historyMsg,
    roomsendMsg,
    giftsend,
    usermute,
    userunmute,
    userStartmute,
    timheatpackage,
  } from "@/api/lz.js";
  import {
    recommendDetail,
    detailForUser,
    fansClubjoin,
    userRelation,
    publish,
    roompublish,
    anchorRecommendList,
    overaccount,
    recommendorder,
    recommendblock,
    recommendunblock,
    watchLive,
    userEquitiesGift,
    configList
  } from "@/api/fans.js";
  import {
    chatRoomAddress
  } from '@/api/wyapi.js'
  import {
    Chatroom
  } from '@yxim/nim-web-sdk'

  let interTime = null
  import {
    matchlastRelevance
  } from "@/api/scope.js";
  import {
    initNIMApi
  } from '@/js_sdk/wysocket.js';
  import appKey from '@/js_sdk/wysocket.js';

  function myguid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  import {setroomleave} from '@/lib/req.js';
  export default {
    inject: ["reload"],
    data() {
      return {
        showNoMsg:{
          num:1,
          state:false,
        },
        timeackage:{},
        noticelsit: ["禁止任何传播违法、违规、低俗等信息的行为，一经发现将予以封禁处理。请勿相信以任何方式的诱导打赏、私下交易等行为，以防人身或财产损失。"],
        sendmsgStatus: true,
        ShowSVGas: true,
        nimparams: {
          nimRoomId: '',
          nimFromAccid: ''
        },
        NIMROOM: {}, // 网易云信socket
        roomNoticetext: null,
        quickgiftList: {},
        changesvga: false, // 显示礼物特效
        timeoutObj: null, // 直播间心跳
        globalTime: null,
        DialogScopeOver: false,
        runbarrageListState: true,
        matchId: '',
        HiddenScope: true,
        animationUrl: '', // 动画链接
        fansState: {}, // 用户与主播粉丝团的关系
        fansdetailForUser: {}, // 粉丝团详情
        addfansGroup: false,
        hitoryorderindex: 1,
        hitoryorderloading: '加载中',
        currentUserinfo: {},
        checkOrderIndex: 1,
        alert_order_seal: false,
        alert_add_order: false,
        alert_order_details: false,
        alert_order_buy: false,
        fansgrouprule: false,
        alert_order_over: false,
        fromorder: {
          amount: '',
          title: '',
          content: '',
          free: 1,
          matchStage: 1,
          matchType: 1,
          watchPrice: ''
        },
        userGreed: false,
        videoSrc: '流畅',
        sourceList: [
          // 流畅(ld)
          // 标清(sd)
          // 高清(hd)
          // 超清(ud)
          {
            name: '流畅',
            id: 'ld'
          },
          {
            name: '标清',
            id: 'sd'
          }, {
            name: '高清',
            id: 'hd'
          },
          {
            name: '超清',
            id: 'ud'
          }

        ],
        socketIndex: 3,
        socketIndex2: 5,
        shenlongicon: true, // 神龙礼物
        isOpenSetting: false, // 是否打开主播等级设置
        selectDatainto: {
          intoSelect: 0,
          saySelect: 0
        },
        selectOPtionlist: {
          say: [{
              label: '无限制',
              value: 0
            },
            {
              label: '1级',
              value: 1
            }, {
              label: '2级',
              value: 2
            }, {
              label: '3级',
              value: 3
            },
            {
              label: '4级',
              value: 4
            },
            {
              label: '5级',
              value: 5
            },
            {
              label: '6级',
              value: 6
            },
            {
              label: '7级',
              value: 7
            },
            {
              label: '8级',
              value: 8
            },
            {
              label: '9级',
              value: 9
            },
            {
              label: '10级',
              value: 10
            }
          ],
          greed: [{
              label: '无限制',
              value: 0
            },
            {
              label: '1级',
              value: 1
            }, {
              label: '2级',
              value: 2
            }, {
              label: '3级',
              value: 3
            },
            {
              label: '4级',
              value: 4
            },
            {
              label: '5级',
              value: 5
            },
            {
              label: '6级',
              value: 6
            },
            {
              label: '7级',
              value: 7
            },
            {
              label: '8级',
              value: 8
            },
            {
              label: '9级',
              value: 9
            },
            {
              label: '10级',
              value: 10
            }
          ]
        },
        lasttimes: '',
        packet_msg: '',
        robPacket: {},
        currentpacket: {},
        isShowpacket: 0,
        showSwtchSource: true,
        Mypackets: [],
        isVideoLoading: true,
        msg: "Hello vue-baberrage",
        imageTime: "", //image时间戳
        piaochuangclass: "",
        shouyeData: {
          list: [],
        }, //首页数据

        barrageIsShow: true,
        currentId: 0,
        barrageLoop: false,
        barrageList: [],
        messageHeight: 40,
        boxHeight: 100,
        maxWordCount: 120,
        throttleGap: 2000,
        lanesCount: 3,

        sendMessage: true, //判断登录发消息
        useridRommid: true, //直播间自己关注自己
        longzhuhao: "", //龙珠号
        liaotian: true, //聊天页面
        zhubopush: false, //推单的显示隐藏
        liwu: 0,
        liwu1: 0,
        liwuu: 12, //礼物个数
        jubao: false, //举报页面显示隐藏
        messageInput: "", //聊天输入框
        liwuLiabiao: false, //礼物列表显示隐藏
        liwuliebiaoIndex: null, //点击后礼物详情的显示隐藏
        liwuliebiao2Index: null, //礼物详情显示隐藏
        tuidan: false, //推单的显示隐藏
        goumai: false, //推单购买的显示隐藏
        fangan: false, //推单方案的显示隐藏
        tracq: false, //管理员名片的显示隐藏
        tracq2: false, //不是管理员名片显示隐藏
        tracq3: false, //超管名片的显示隐藏
        tracqXinxi: [], //名片信息的数据
        houseTracq: false, //房主打开名片
        oneselfTracq: false, //自己的名片显示隐藏
        quanxian: [], //名片权限
        ban: false, //封停页面的显示隐藏
        yiruIndex: 0,
        nameindex: null, //动态Css聊天name
        liwudata: [], //礼物列表数据
        liwufenleiindex: 0, //礼物分类索引
        beibao: false, //背包礼物的显示隐藏
        haohualiwu: true, //豪华礼物的显示隐藏
        radio: "1", //推单收费价格
        radio2: "1", //推单时间
        tuidanneirong: "", //主播发布推单内容
        tuidanbiaoti: "", //推单标题
        tuidanlishi: [], //主播历史推单的数据
        tuidanIndex: 0, // 推单的索引
        rtl: "rtl",
        messagesss: [],

        bottom: 40,
        radiomoney: "0", //推单钱数

        visitable: false,
        id: "",
        // source:'https://alihdl9001.plures.net/live/e522087a-a681-40ca-a7b7-fa2ddc487cb4.flv?auth_key=1636112830-0-0-c62dc5a9c1100c43a364617d5a38e2e9',
        source: "", //直播拉流地址
        isLive: true, //直播
        title: "",
        OverLiveAtreaming: false,
        // path:"ws://192.168.0.118:2001/websocketServer",
        socket: "", //ws 存放地址
        a: {
          //ws接口参数
          product: "lz",
          module: "chat",
          roomid: 0,
          userid: 0,
        },
        accessToken: "", //ws  token参数
        message: [], //JSON转译后的ws信息
        // message2:[],
        broadcastingData:{}, //头部数据
        paihangbanData: [], //排行榜数据
        paihangbanglongbi: true, //龙币或者贡献
        tuidanmessage: [], //推单数据
        Newesttuidan: {}, //最新推单数据
        Twitterlist: true, //主播发布推单
        fanganContent: "", //推单内容
        userUid: 0, //要禁言的用户UID
        dizhi: "", //页面地址
        fenxiang: false, //分享显示隐藏
        money: "", //获取龙币余额
        broadcast: [], //结束直播推荐数据
        // dsa:"ws://chat.ansongqiubo.com/websocketServer?product=lz&module=chat&roomid="+this.a.roomid+"&userid="+this.a.userid+"&accessToken="+this.accessToken
        dignshiqi: null,
        activeVideo: 1,
        heat: "",
        guanbi: false,
        weiguanzhuZhubo: true,
        yiguanzhuZhubo: false,
        guanzhuListId: [], //关注列表uid
        tracqAttentionRelation: 1, //名片关注列表关系
        tracqShutupRelation: 1, //名片禁言列表关系
        tracqManageRelation: 1, //名片房管列表关系
        management: [], //房间管理员列表
        RankingIndex: 0, //排行榜索引
        jinyan: false, //发言禁言提示
        jinyanCentent: "", //禁言内容
        shanchuindex: [], //删除index
        message1: [],
        shanchuindex2: [],
        globalWs: {
          product: "lz",
          module: "global",
          roomid: 0,
          userid: 0,
        }, //全局websockt参数
        accessToken2: "", //ws  token参数
        xiaoxiduilie: [],
        xiaoxishuju: {},
        yanseindex: -1,
        shenlongData: {}, //全局sockt 神龙礼物数据
        shenlongDataList: [], //全局sockt 神龙礼物数据
        shenlongCurrentDataList: [], //全局sockt 神龙礼物数据
        shenlongstatus: true,
        shenlongIndex: 0,
        liwuData: [], //礼物数据
        socket2: {},
        liwudonghuaduilie: [],
        noLoginInitRoomStatus: false,
        muteData:{},
        closeVideLiveData:{},
        closeVideLives:false,
        shutTimes:null,
        virtualId:'',
        AnchorTaskList:{
            "taskId":'',// 任务ID
            "completeState":0,// 任务完成状态，0：默认，未完成，1：已完成，奖励待领取，2：奖励已领取
            "taskTarget":'', // 任务指标
            "completeTarget": '',// 任务已完成的指标
            "completeTimeSec":'', // 任务完成时间(秒值)
            "touchTimeSec": '' // 任务触发的时间(秒值)
        }
      };
    },
    async created() {
      this.imageTime = Date.parse(new Date()) / 1000;

      setTimeout(() => {
        this.getRedpacket();

      }, 100);
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
      nameFilters(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
      LiveStreamingTitle(value) {
        if (!value) return "";
        if (value.length > 15) {
          return value.slice(0, 15) + "...";
        }
        return value;
      },
      LiveStreamingName(value) {
        if (!value) return "";
        if (value.length > 8) {
          return value.slice(0, 8) + "...";
        }
        return value;
      },
    },
    mounted() {
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL);
        window.addEventListener("popstate", this.AddList, false);
      }
      this.a.roomid = this.$route.query.roomId; // 房间id
      this.virtualId = this.$route.query.virtualId; // 房间id
      clearInterval(interTime);
      document.addEventListener("click", (e) => {
        let thisclassName = e.target.className;
        if (thisclassName !== "fenxiangclass") {
          setTimeout(() => {
            this.fenxiang = false;
          }, 100);
        }
      });
      this.dizhi = window.location.href;
      var self = this
      document.addEventListener("visibilitychange", function() {
        if (document.visibilityState == "hidden") {
          console.log('离开到该页面');
          self.quit()
          self.barrageList = []
          self.barrageIsShow = false
          //切离该页面时执行
        } else if (document.visibilityState == "visible") {
          //切换到该页面时执行
          console.log('切换到该页面');
          self.barrageList = []
          self.barrageIsShow = true
        }
      });
      this.initRoomInfo()
      setTimeout(()=>{
        this.FifshutData()
      },2000)
    },
    methods: {
      AddList(){
        console.log('111111111111111111111111111111111111111111111111');
      },
      // 改变热度包
      changePack(){
        // 刷新余额
        this.getMoneys(2)
        // 刷新时间
        this.gettimheatpackage();
      },
      gettimheatpackage(){
        timheatpackage({}).then(result=>{
          if(result.data.code == 200){
            console.log('刷新热度包成功');
            this.timeackage = result.data.data;
          }
        })
      },
      FifshutData(){

        // // 测试数据
        // this.liaotian = false;
        // this.muteData = {
        //   "expireTime": 10, //-1=永久 或 时间戳  //解封时间
        //   "reason":1, //禁言原因类型:1=色情暴力2=反动政治3=侵权4=广告欺诈5=其他
        //   "remainTime":3666, //-1=永久 或 xxx(秒) //剩余时间
        //   "roomid":1,//房间id
        // };

        // 记录禁言的的状态及时间
        let strtime  = moment('2020-11-16','YYYY-MM-DD').add(this.muteData.remainTime, 'second');
        let timeIndex = 1;
        clearInterval(this.shutTimes)
        this.shutTimes = setInterval(()=>{
            if(this.muteData.remainTime  > 0 && timeIndex < this.muteData.remainTime){
                // this.muteData.remainTime =  Number(this.muteData.remainTime) - 1;
                timeIndex ++;
                if (this.muteData.remainTime > 3600) {
                  this.muteData.strtime =  moment(strtime).subtract(timeIndex, 'second').format('HH:mm:ss');
                } else {
                  this.muteData.strtime  =  moment(strtime).subtract(timeIndex, 'second').format('mm:ss');
                }
                this.$forceUpdate()
                console.log('定时器',timeIndex,this.muteData.remainTime,this.muteData.remainTime );
            }else{
              this.liaotian = true;
              strtime = ''
              clearInterval(this.shutTimes)
              console.log('定时器', this.muteData);
            }
        },1000)
      },
      FifshutData2(){

        // 测试数据
        // this.closeVideLives = true;
        // this.closeVideLiveData = {
        //   "expireTime": 10, //-1=永久 或 时间戳  //解封时间
        //   "reason":1, //禁言原因类型:1=色情暴力2=反动政治3=侵权4=广告欺诈5=其他
        //   "remainTime":3666, //-1=永久 或 xxx(秒) //剩余时间
        //   "roomid":1,//房间id
        // };



        // 记录禁言的的状态及时间
        let strtime  = moment('2020-11-16','YYYY-MM-DD').add(this.closeVideLiveData.remainTime, 'second');
        let timeIndex = 1;
        clearInterval(this.shutTimes)
        this.shutTimes = setInterval(()=>{
            if(this.closeVideLiveData.remainTime  > 0 && timeIndex < this.closeVideLiveData.remainTime){
                // this.closeVideLiveData.remainTime =  Number(this.closeVideLiveData.remainTime) - 1;
                timeIndex ++;
                if (this.closeVideLiveData.remainTime > 3600) {
                  this.closeVideLiveData.strtime =  moment(strtime).subtract(timeIndex, 'second').format('HH:mm:ss');
                } else {
                  this.closeVideLiveData.strtime  =  moment(strtime).subtract(timeIndex, 'second').format('mm:ss');
                }
                this.$forceUpdate()
                console.log('定时器',timeIndex,this.closeVideLiveData.remainTime,this.closeVideLiveData.remainTime );
            }else{
              strtime = ''
              this.closeVideLives = false;
              clearInterval(this.shutTimes)
              console.log('定时器', this.closeVideLiveData);
            }
        },1000)
      },
      // 禁言管理
      FifmuteData(state){
        // //禁言原因类型:1=色情暴力2=反动政治3=侵权4=广告欺诈5=其他
        switch (state){
          case 1:
            return '色情暴力'
            break;
          case 2:
            return '反动政治'
            break;
          case 3:
            return '侵权'
            break;
          case 4:
            return '广告欺诈'
            break;
          case 5:
            return '违规'
            break;
          default:
            return ''
            break;
        }
      },
      // 用户等级
      fifGreed(v){
        if(v > 60){
          v  = 60
        }
        return v
      },
      // 等级标签
      fifLabelName(v) {
        let obj = {};
        if (v >= 1 && v <= 3) {
          obj.name = '鳜都司'
          obj.bg = 1
        } else if (v >= 4 && v <= 6) {
          obj.name = '鳜少卿'
          obj.bg = 2
        } else if (v >= 7 && v <= 9) {
          obj.name = '鲌太尉'
          obj.bg = 3
        } else if (v >= 10 && v <= 12) {
          obj.name = '鲭太尉'
          obj.bg = 4
        } else if (v >= 13 && v <= 15) {
          obj.name = '鳝力士'
          obj.bg = 5
        } else if (v >= 16 && v <= 18) {
          obj.name = '鯾提督'
          obj.bg = 6
        } else if (v >= 19 && v <= 21) {
          obj.name = '鲤总兵'
          obj.bg = 7
        } else if (v >= 22 && v <= 24) {
          obj.name = '鲤元帅'
          obj.bg = 8
        } else if (v >= 25 && v <= 27) {
          obj.name = '鲤太宰'
          obj.bg = 9
        } else if (v >= 28 && v <= 30) {
          obj.bg = 10
          obj.name = '鱑把总'
        } else if (v >= 31 && v <= 33) {
          obj.name = '机巧鼋'
          obj.bg = 11
        } else if (v >= 34 && v <= 36) {
          obj.name = '玄微鬼'
          obj.bg = 12
        } else if (v >= 37 && v <= 39) {
          obj.name = '亀丞相'
          obj.bg = 13
        } else if (v >= 40 && v <= 42) {
          obj.name = '鲇外郎'
          obj.bg = 14
        } else if (v >= 43) {
          obj.name = '鲫军师'
          obj.bg = 15
        } else {
          obj.name = false
          obj.bg = false
        }
        return obj
      },
      // 关闭礼物动画
      changeSwitch(e) {
        this.ShowSVGas = e
        if (e) {
          this.$message.success('已恢复礼物特效')
        } else {
          this.$message.success('已屏蔽礼物特效')
        }
      },
      async noLoginInitRoom(rooomid) {
        if (this.noLoginInitRoomStatus) {
          console.log('不用刷新了')
          return
        }
        this.noLoginInitRoomStatus = true;
        let that = this;
        this.message1.push({
          currentUser: {},
          message: {
            systemtext: '正在连接弹幕服务器···',
          }
        })
        let result = await chatRoomAddress({
          roomId: rooomid
        });
        if (result.data.code == 200) {
          let {
            addressList,
            roomId
          } = result.data.data;
          console.log('匿名登录', appKey, rooomid, addressList, this.noLoginInitRoomStatus);
          Chatroom.getInstance({
            "appKey": appKey, //  生产 1455eac28ddf0b89284455d704af7532   测试 0bfe8e9f7530e5e8a4ce31cd96b48375
            "chatroomId": rooomid,
            "chatroomAddresses": addressList,
            "chatroomNick": 'Visitor',
            "chatroomAvatar": 'https://oss.ansongqiubo.com/assets/touxiang2.png',
            "isAnonymous": true,
            "onconnect": onChatroomConnect,
            "onerror": onChatroomError,
            "onmsgs": onChatroomMsgs
          });

          function onChatroomConnect(obj) {
            // 该处chatroom为全局生成的实例
            console.log('弹幕服务器加载成功');
            that.message1.push({
              currentUser: {},
              message: {
                systemtext: '弹幕服务器加载成功',
              }
            })
            // 直播间历史聊天记录
            historyMsg({
              roomId: that.a.roomid
            }).then((res) => {
              var lishi = res.data.data;
              that.message1 = that.message1.concat(lishi.reverse());
            });
          }

          function onChatroomError(error, obj) {
            console.log('发生错误', error, obj);
          }

          function onChatroomMsgs(msgs) {
            msgs.map(item => {
              let msg = JSON.parse(item.text);
              console.log('收到聊天室消息', msg);
              that.getMessage(msg)
            })

          }
          console.log('获取历史聊天记录', that.message1)
        }
      },
      // 登录解析网易云信
      async eventnim() {
        const eventList = [
          // about login
          'logined', // 初始化成功登陆
          'willReconnect', // 开始自动重连
          'disconnect', // 连接断开
          'kicked', // 被踢下线
          // multi client login notification
          'multiPortLogin',
          // receive chatroom message
          'chatroomMsg' // 收到消息
        ]

        eventList.forEach((key) => {
          this.NIMROOM.on(key, (res) => {
            switch (key) {
              case 'logined':
                console.log('网易云信聊天室----初始化成功登陆');

                break;
              case 'chatroomMsg':
                console.log('网易云信聊天室----接收新消息', res.body);
                this.getMessage(res.body)
                break;
              case 'willReconnect':
                this.getMessage({
                  data: JSON.stringify({
                    currentUser: {},
                    fans: {},
                    message: {
                      content: '开始自动重连···'
                    },
                    messageType: 11111
                  })
                })
                console.log('网易云信聊天室----开始自动重连');
                break;
              case 'disconnect':
                this.getMessage({
                  data: JSON.stringify({
                    currentUser: {},
                    fans: {},
                    message: {
                      content: '链接断开···'
                    },
                    messageType: 11111
                  })
                })
                console.log('网易云信聊天室----链接断开');
                break;
              case 'kicked':

                console.log('网易云信聊天室----被踢下线');
                break;
              default:
                break;
            }
          });
        })
      },
      // 给他重置一下----下个版本
      initRoomInfo() {
        // this.a.roomid = this.$route.params.idasd;
        // 获取某个直播间信息
        // 获取直播间公告
        roomnotice({}).then(roomResult => {
          if (roomResult.data.code == 200) {
            console.log('直播间公告', roomResult);
            this.roomNoticetext = roomResult.data.data.roomNotice;
            this.roomNoticetext = this.roomNoticetext.slice(4, this.roomNoticetext.length);
            // this.noticelsit.push( this.roomNoticetext)
          }
        })
        roomInfo({
          uid: this.a.roomid,
          versionCode:110,
          virtualId:this.virtualId
        }).then(async (res) => {
          if(res.data.code == 200){
            if (res.data.data.room.isLive == 0) {
              this.OverLiveAtreaming = true;
            }
            let categoryType = res.data.data.category;
            console.log('直播间信息',categoryType, this.a.roomid, res.data);
            if(categoryType.categoryPkey == 'football'){
              this.getScope()
            }

            this.longzhuhao = res.data.data.user.account;
            this.broadcastingData = res.data.data;
            // 处理 视频播放流
            console.log('聊天室id', res.data.data.nim.nimRoomId, this.NIMROOM);
            if (localStorage.getItem("token")) {
              // 链接网易----- 登录后连接
              this.message1 = []
              if (res.data.data.nim.nimRoomId) {
                initNIMApi(res.data.data.nim.nimRoomId.toString(), (resStatus) => {
                  if (resStatus == 1) {
                    this.message1.push({
                      currentUser: {},
                      message: {
                        systemtext: '正在连接弹幕服务器···',
                      }
                    })
                  }
                  if (resStatus == 2) {
                    this.message1.push({
                      currentUser: {},
                      message: {
                        systemtext: '弹幕服务器加载成功',
                      }
                    })
                    // 直播间历史聊天记录
                    historyMsg({
                      roomId: this.a.roomid
                    }).then((res) => {
                      var lishi = res.data.data;
                      this.message1 = this.message1.concat(lishi.reverse());
                    });
                  }
                  console.log('网易云信初始化状态', resStatus);
                }).then(res => {
                  this.NIMROOM = res;
                  this.nimparams.nimFromAccid = this.NIMROOM.options.account;
                  this.nimparams.nimRoomId = this.NIMROOM.options.chatroomId;
                  this.eventnim();
                  if (localStorage.getItem("token")) {
                    this.into();
                  }
                  console.log('直播间聊天记录', this.NIMROOM);
                });
              }

              this.showSwtchSource = false
              // 登录默认给高清
              this.source = res.data.data.hd.flv;
              let listSource = []
              this.videoSrc = '高清'
              listSource = [{
                  name: '流畅',
                  id: 'ld'
                },
                {
                  name: '标清',
                  id: 'sd'
                }, {
                  name: '高清',
                  id: 'hd'
                },
              ]



              // 加入粉丝团的可以选择超清
              let result = await userRelation({
                anchorUId: this.a.roomid
              })
              if (result.data.code == 200) {
                this.fansState = result.data.data;
                let i = result.data.data.fansClubState // 0：不是该粉丝团的粉丝， 1:正常加入中，-1：权益已过期, 2:当前粉丝团的所属者
                if (i == 1) {

                  // 定时器回调
                  let timelook = () => {
                    setTimeout(() => {
                      // 观看时长上报
                      watchLive({
                        anchorUId: this.a.roomid
                      }).then(res => {
                        if (res.data.code == 200) {
                          if (res.data.data != 2) {
                            timelook()
                          }
                        }
                      })
                    }, 5 * 60 * 1000)
                  }
                  timelook()
                  listSource = [{
                      name: '流畅',
                      id: 'ld'
                    },
                    {
                      name: '标清',
                      id: 'sd'
                    }, {
                      name: '高清',
                      id: 'hd'
                    },
                    {
                      name: '超清',
                      id: 'ud'
                    }
                  ]
                  console.log('粉丝团与主播的关系', this.sourceList, i);
                }
              }
              this.sourceList = listSource
            } else {


              setTimeout(()=>{
                this.showNoMsg.state = true;
                this.showNoMsg.num = Math.floor(Math.random() * 6) + 2;
              },5000);



              if (res.data.data.nim.nimRoomId) {
                console.log('获取网易云信的appKey', appKey);
                // 网易云信匿名登录
                // this.noLoginInitRoom(res.data.data.nim.nimRoomId)

                // 直播间历史聊天记录
                historyMsg({
                  roomId: this.a.roomid
                }).then((res) => {
                  var lishi = res.data.data;
                  this.message1 = this.message1.concat(lishi.reverse());
                });
              }
              // 不登录只给标清，点击高清时提示登录
              this.showSwtchSource = true
              this.source = res.data.data.playStreamInfo.flv;
              this.videoSrc = '标清'
              this.sourceList = [

                {
                  name: '流畅',
                  id: 'ld'
                },
                {
                  name: '标清',
                  id: 'sd'
                }, {
                  name: '高清',
                  id: 'hd'
                },
              ]
            }

            setTimeout(() => {
              this.isVideoLoading = false;
            }, 1200);
            // 获取流
            this.streams();
          }else if(res.data.code == -1){
            this.broadcastingData = res.data.data;
            this.OverLiveAtreaming  = true
          }else{
            // this.$message.success(res.data.message);
            console.error(res.data.message);
          }
        });
        this.hitoryorderindex = 1;
        // 推单历史
        // this.getLishiTuidan()
        // 用户登录状态
        if (localStorage.getItem("token")) {

          //


          // 获取龙币余额
          this.getMoneys();
          this.sendMessage = true;
          //  获取用户id
          this.$store.dispatch('getUserInfoData').then((result) => {
            console.log('获取用户信息', result);
            this.a.userid = result.userInfo.uid;
            this.currentUserinfo = result.userInfo;
            if (this.a.roomid == this.a.userid) {
              this.useridRommid = false;
              this.Twitterlist = true;
              this.gettimheatpackage()
            } else {
              this.Twitterlist = false;
            }
            // ASSCI码升序排序
            var arr = new Array();
            var num = 0;
            for (var i in this.a) {
              arr[num] = i;
              num++;
            }
            var sortArr = arr.sort();
            var sortObj = {};
            for (var i in sortArr) {
              sortObj[sortArr[i]] = this.a[sortArr[i]];
            }
            // 接口拼接
            var assci =
              sortArr[0] +
              "=chat" +
              "&" +
              sortArr[1] +
              "=lz" +
              "&" +
              sortArr[2] +
              "=" +
              this.a.roomid +
              "&" +
              sortArr[3] +
              "=" +
              this.a.userid +
              "&" +
              "salt=12345";
            // md5加密
            this.accessToken = this.$md5(assci);
            // 初始化ws链接ws接口
            // 初始化ws链接ws接口2
            this.lianjie2(); //  登录
          });
          // 和主播关注关系
          this.$store.dispatch('getUserFollowData', 2).then(result => {
            console.log('直播间我的关注列表·', result);
            let i = result.findIndex(v => v.uid == this.a.roomid);
            if (i >= 0) {
              this.weiguanzhuZhubo = false;
              this.yiguanzhuZhubo = true
            } else {
              this.weiguanzhuZhubo = true;
              this.yiguanzhuZhubo = false;
            }
          }); // 获取当前直播间权限设置等级
          this.getLevelData()
        } else {
          this.sendMessage = false;
          this.a.userid = 0;
          this.Twitterlist = false;
          // ASSCI码升序排序
          var arr = new Array();
          var num = 0;
          for (var i in this.a) {
            arr[num] = i;
            num++;
          }
          var sortArr = arr.sort();
          var sortObj = {};
          for (var i in sortArr) {
            sortObj[sortArr[i]] = this.a[sortArr[i]];
          }
          // 接口拼接
          var assci =
            sortArr[0] +
            "=chat" +
            "&" +
            sortArr[1] +
            "=lz" +
            "&" +
            sortArr[2] +
            "=" +
            this.a.roomid +
            "&" +
            sortArr[3] +
            "=" +
            this.a.userid +
            "&" +
            "salt=12345";
        }
        // 主播下拨后推荐数据流
        this.$axios
          .get(this.api + "/v2/list/streams", {
            params: {
              pcatId: 1,
              pageIndex: 0,
              catId: 1,
            },
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
            },
          })
          .then((res) => {
            //   console.log(res);
            this.broadcast = res.data.data.list;
          });
        //获取礼物列表
        this.$axios({
          url: this.api + "/v1/gift/list",
          method: "GET",
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "Content-Type": "application/json",
          },
        }).then((res) => {
          this.liwudata = res.data.data;
          // 用户 粉丝团礼物权益列表
          userEquitiesGift({
            anchorUId:this.a.roomid
          }).then(res=>{
            if(res.data.code == 200){
              this.EquitiesGift  = res.data.data;  // 礼物列表
              this.liwudata.map(Item=>{
                if(Item.categoryKey =='fans_club'){
                  Item.gifts.map(Items=>{
                   let arrs =  this.EquitiesGift.filter(vals => vals.giftId ==   Items.id );
                   if(arrs.length!=0){
                     Items = Object.assign(Items,arrs[0]);
                     return Items
                   }
                  })
                  return Item
                }
              })


              console.log('新礼物列表',  this.liwudata);
            }
          })
        });
        // 快捷礼物
        quickgift({}).then(res => {
          if (res.data.code == 200) {
            console.log('快捷礼物', res.data);
            this.quickgiftList = res.data.data
          }
        })

        try {
          setTimeout(() => {
            this.changePlay(1);
          }, 2200)
        } catch (e) {
          //TODO handle the exception
        }
      },
      // 获取活动中心
      getActives(){
        configList({}).then(result=>{
          if(result.data.code == 200){
            console.log('当前任务活动',result.data.data);
            let arrs =  result.data.data;
            var states = true;
            let token  = localStorage.getItem('token')
            arrs.some(item=>{
              let {activityType,state} =item;
              if(activityType == 1 ){
                if(state == 0){
                  let iframeUrl = ` http://t-new.longzhu.com/act/#/activity/1?plat=pc&t=${token}`;
                  this.openiframe(iframeUrl);
                  states = false;
                }
              }
            })
           setTimeout(()=>{
             if(states){
               this.$message.error('当前没有可参与的活动，敬请期待~'+states)
             }
           },100)

          }else{
            console.log('检查活动',result.data.message);
          }
        })
      },
      openiframe(val){
        this.$refs.myactivedialogs.openiframe(val)
      },
      openreceivetask(e){
          this.$refs.receivetask.open()
      },
      // 发送快捷消息
      barrageSendClick(item) {
        this.messageInput = item;
        this.send();
      },
      // 切换快捷消息提示
      closeroomMessage(state) {
        if(state){
          this.runbarrageListState = false;
        }else{
          this.runbarrageListState = true;
        }
      },
      playReady() {
        console.log('播放器播放。。。。。。。。。。。。。。。。。。。。。。。。。。。。')
      },
      navtoUpdata() {
        this.DialogScopeOver = false;
        this.$NewRouter(`/v2/my/showset`);
        // const neww = this.$router.resolve({
        //   path: "/tianjiazhiboyuan",
        //   query: {
        //     id: 8,
        //     tab: 2,
        //   },
        // });
        // window.open(neww.href, "_self");
      },
      changeAlert() {
        console.log('结束直播了，提醒主播3');
        // 只提示当前主播显示
        if (this.sendMessage && this.Twitterlist) {
          this.DialogScopeOver = true;
          console.log('结束直播了，提醒主播4');
          setTimeout(() => {
            this.DialogScopeOver = false;
          }, 1000 * 60 * 10)
        }
      },
      changeChild(data) {
        if (this.$refs.roomScope) {
          console.log('刷新直播间数据。。。。。。。。。。。', data.messageType, data)
          this.$refs.roomScope.fiflterScopeData(data)
        }
      },
      getScope() {
        matchlastRelevance({
          anchorId: this.a.roomid,
        }).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data && res.data.data.matchVO && res.data.data.matchVO.matchId > 0) {
              this.matchId = res.data.data.relevanceMatchInfoVO.matchId;
            };
          }
          console.log("查询主播最新关注的信息", this.matchId);
        });
      },
      scopeAnimal(e) {
        this.animationUrl = e
      },
      // 切换动画
      changePlay(e) {
        this.activeVideo = e
        if (e == 2) {
          console.log('暂停');
          if (this.$refs.player) this.$refs.player.pause();
        } else {
          console.log('播放');
          if (this.$refs.player) this.$refs.player.play();
        }
      },
      // 查询推单详情
      getrecommendDetail(id, status) {
        recommendDetail({
          recommendId: id
        }).then(res => {
          if (res.data.code == 200) {
            this.fanganContent = res.data.data;
            if (status == 10403) {
              this.message.push({
                messageType: 10403,
                message: this.fanganContent
              });
            }
            if (status == 10402) {
              this.message.push({
                messageType: 10402,
                message: this.fanganContent
              });
            }
          }
          console.log('推单详情请求', res.data.data);
        })
      },
      downloadApp() {
        this.addfansGroup = false;
        this.$NewRouter(`/pageFull?rid=9`);
        // const neww = this.$router.resolve({
        //   path: "/download",
        //   query: {
        //     rid: 9,
        //     infoId: 0,
        //     valId: 1
        //   },
        // });
        // window.open(neww.href, "_self");
      },
      // 加入粉丝团
      addjoinfans() {
        fansClubjoin({
          anchorUId: this.a.roomid
        }).then(res => {
          console.log('加入粉丝团', res);
          if (res.data.code == 200) {
            this.$message.success('加入成功')
            // 刷新关系
            userRelation({
              anchorUId: this.a.roomid
            }).then(result => {
              if (result.data.code == 200) {
                this.fansState = result.data.data;
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
          this.addfansGroup = false
        })
      },
      //打开加入粉丝团
      addFans() {
        if (!localStorage.getItem("token")) {
          this.$message.error('请登录够操作');
          // 打开登录
          this.denglu()
          return
        }

        console.log('粉丝团关系', this.fansState);
        // 判断该主播有没有开通粉丝团
        if (this.fansState.fansClubState == 0) {
          this.$message.error('主播还未开通粉丝团')
          return
        }
        if (this.fansState.fansClubState == -2) {
          this.$message.error('主播的粉丝团已解散')
          return
        }
        if (this.fansState.fansClubState == -1) {
          this.$message.error('主播的粉丝团不可用') // 查询粉丝团信息
          return
        }
        if (this.fansState.fansClubState == 1) {
          if (this.fansState.fansUserState == 0 || this.fansState.fansUserState == 1 || this.fansState.fansUserState ==
            -1) { // 不是粉丝团成员
            // 查询粉丝团信息
            detailForUser({
              anchorUId: this.a.roomid
            }).then(res => {
              if (res.data.code == 200) {
                this.fansdetailForUser = res.data.data
                console.log('可以加入粉丝团', this.fansdetailForUser);
              }
            })
          }
          // if( this.fansState.fansUserState == 1){ // 不是粉丝团成员
          //    return this.$message.error('已经加入粉丝团了')
          // }
        }


        // 判断是否加入过粉丝团了


        this.addfansGroup = true
      },
      chageRadio(e) {
        console.log(e);
        this.fromorder.amount = ''
      },
      // 解除封单
      openOrderdata(val) {
        recommendunblock({
          recommendId: val.recommendId
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('订单已经封单');
            this.hitoryorderindex = 1
            this.alert_order_details = false;
            this.getLishiTuidan()
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      loadorderlist() {
        console.log('jiazai1');
        this.getLishiTuidan()
      },
      // 购买推单
      buyOrder(id) {
        recommendorder({
          recommendId: id,
          idempotence: myguid(),
        }).then(res => {
          console.log('购买推单结果', res);
          if (res.data.code == 200) {
            this.$message.success('购买成功');
            this.alert_order_buy = false;
            // 刷新历史推单  刷新价格
            this.hitoryorderindex = 1;
            this.getLishiTuidan()

          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      async getMoneys(type = 1) {
        let result = await this.$store.dispatch('getUserMoneyData', type);
        console.log('我余额数据', result);
        this.money = result.dragonCoin;
      },
      // q确认结单
      overorderStatus() {
        overaccount({
          accountResult: this.checkOrderIndex, // 1：红，2：走，3：黑
          recommendId: this.fanganContent.recommendId, // 推单id
          accountScore: '', // 接单时比分
        }).then(res => {
          if (res.data.code == 200) {
            console.log('确认结单', res);
            this.alert_order_over = false;
            this.$message.success('结单成功')
            this.hitoryorderindex = 1
            this.getLishiTuidan()
          } else {
            this.$message.error(res.data.code)
          }
        })
      },
      sealOrder() {
        recommendblock({
          recommendId: this.fanganContent.recommendId
        }).then(res => {
          if (res.data.code == 200) {
            this.hitoryorderindex = 1
            this.getLishiTuidan()
            this.$message.success('封单成功');
            this.alert_order_seal = false
            this.alert_order_details = false;
          } else {
            this.$message.error(res.data.message)
          }
        })
      },
      // 打开结单
      overOrderdata(val) {
        if (val) {
          this.alert_order_seal = true;
        } else {
          this.alert_order_over = true;
          this.alert_order_details = false;
        }
      },
      //聊天推单切换
      changeChat(val) {
        if (val) {
          this.liaotian = true;
        } else {
          this.hitoryorderindex = 1
          this.getLishiTuidan()
          this.liaotian = false;
        }
      },
      fifTime(time) {
        // console.log('时间转换',time);
        return moment.unix(time).format('YYYY-MM-DD HH:mm:ss')
      },
      // 打开推单详情
      navOrderdetails(val) {
        this.alert_order_buy = false
        this.alert_order_details = false;
        console.log('推单详情', val);
        this.getrecommendDetail(val.recommendId)
        setTimeout(() => {
          // 判断 1.当前用户是主播； 2.用户购买过推单的；3.是守护的 4.免费推单  显示详情
          if (this.Twitterlist || val.viewState == 1 || val.viewState == 2 || val.free == 1) {
            this.alert_order_details = true;
          } else {
            //已结单的不点击
            if (val.state == 0 || val.state == 2) {
              this.alert_order_buy = true;
              return
            }
            if (val.state == 2) {
              this.$message.error('当前推单封单中，不能购买')
              return
            }
            if (val.state == 3) {
              this.$message.error('当前推单已结接单了')
              return
            }
          }
          console.log(this.broadcastingData, this.a.userid);

        }, 255)

      },
      // 发布推单
      async pushData() {
        let {
          amount,
          title,
          content,
          free,
          matchStage,
          matchType,
          watchPrice
        } = this.fromorder;

        console.log('参数', this.fromorder);
        if (!title) {

          return this.$message.error('请输入标题')
        }

        let keyWord = await this.$store.dispatch('fifWord', {
          key: "orderNamelist",
          value: title
        })
        if (keyWord.state) {
          title = keyWord.value;
        } else {
          return
        }



        if (!content) {
          return this.$message.error('请输入推单内容')
        }
        if (free == 1) {
          this.fromorder.amount = 0
          amount = 0
        }
        if (free == 2 && (amount == '' || amount <= 0)) {
          return this.$message.error('龙币大于0')
        }
        publish({
          amount: amount,
          title: title,
          content: content,
          matchStage: matchStage,
          free: free,
          matchType: matchType,
          watchPrice: watchPrice ? watchPrice : 0,
          firstCategoryId: '',
          secondCategoryId: '',
          resource: 1,
        }).then(res => {
          if (res.data.code == 200) {
            this.$message.success('发布成功!');
            this.alert_add_order = false
          } else {
            this.$message.error(res.data.message)
          }
          console.log('发布推单结果', res);
        })
      },
      pushOrder() {
        // 判断主播等级是否达到4级
        let greeds = this.broadcastingData.user.level;
        if (greeds > 3) {
          this.alert_add_order = true;
        } else {
          this.userGreed = !this.userGreed;
        }
      },
      async getLevelData() {
        let res = await getLevel({
          roomId: this.a.roomid,
        })
        if (res.data.code == 200) {
          this.selectDatainto.intoSelect = res.data.data.join
          this.selectDatainto.saySelect = res.data.data.chat
        }
      },
      switchsrc(val) {
        if (val == 'hd' && !this.sendMessage) {
          this.showSwtchSource = true;
          return
        }
        this.$refs.player.pause();
        switch (val) {
          case 'ld':
            this.source = this.broadcastingData.ld.flv
            // this.source = 'https://sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo-720p.flv'
            // this.source =  "https://pull.cdyinyicp.cn/live/0fc0bd8b-e24f-445a-b96f-bcf5477d783c.flv?auth_key=1652098482-0-0-d7e657b1e40d5817bfb1cefe0b09eb73"
            break;
          case 'sd':
            this.source = this.broadcastingData.sd.flv
            // this.source = 'https://sf1-hscdn-tos.pstatp.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo-360p.flv'
            // this.source =   "https://pull.cdyinyicp.cn/live/413f0265-5163-4dcf-9370-cf99f1abbd8c.flv?auth_key=1652098482-0-0-f91158c0bf90cdb942f045630551bdf5"
            break;
          case 'hd':
            this.source = this.broadcastingData.hd.flv
            break;
          case 'ud':
            this.source = this.broadcastingData.ud.flv
            break;
          default:
            break;
        }
        this.$refs.player.loadByUrl(this.source);
        console.log('切换成功了吗', val, this.source);
      },
      // 点击默认关闭
      maskHidden() {
        this.isOpenSetting = false; // 关闭设置直播权限
        this.liwuLiabiao = false;
        this.addfansGroup = false
        this.userGreed = false;
        this.oneselfTracq = false
        this.tracq = false
        this.LiwufenleiIndex(0)
      },
      setchangeinto1(e) {
        console.log(e, '1');
        this.selectDatainto.intoSelect = e
        this.requestgreeds()
      },
      async requestgreeds() {
        let result = await setLevel({
          roomId: this.a.roomid,
          join: this.selectDatainto.intoSelect,
          chat: this.selectDatainto.saySelect
        })
        if (result.data.code == 200) {
          this.$message({
            message: "设置成功",
            type: "success",
          })
        }
        let res = await getLevel({
          roomId: this.a.roomid,
        })
        console.log('设置权限', result, res.data);
      },
      setchangeinto2(e) {
        console.log(e, '2');
        this.selectDatainto.saySelect = e
        this.requestgreeds()
      },
      openSetting() {
        this.isOpenSetting = !this.isOpenSetting
      },
      // 红包倒计时
      lastTime() {
        let value = this.currentpacket.remainTime;
        if (value && value > 0) {
          value = Number(value);
        }
        console.log('倒计时时间', value)
        let a = new Date()
        clearInterval(interTime);
        interTime = setInterval(() => {
          if (value == 0) {
            clearInterval(interTime);
            this.getRedpacket()
            return
          }
          value = value - 1;
          this.lasttimes = moment(moment(a).add(value, 's').valueOf() - moment(a).valueOf()).format('mm:ss')
        }, 1000);
      },
      // 关闭红包
      closepackets() {
        this.isShowpacket = 0;
        this.getRedpacket()
      },
      // 打开红包
      async openRedPackets() {
        let {
          expireTime,
          orderId
        } = this.currentpacket;
        let moneyspacket = await snatchnvelope({
          roomId: this.a.roomid,
          orderId: orderId,
        });
        if (moneyspacket.data.code == 200 && moneyspacket.data.message == "success") {
          this.robPacket = moneyspacket.data.data;
        } else {
          if (moneyspacket.data.code == 20309) {
            this.packet_msg = moneyspacket.data.message
          }
        }
        this.isShowpacket = 2;
        // 获取龙币余额
        this.getMoneys(2)
        this.getRedpacket();
        console.log("抢到的红包", this.robPacket);
      },
      // 显示红包
      showRedPackets() {
        if (this.currentpacket.remainTime > 0) {
          this.$message('还未到开抢时间哦')
          return
        }
        if (this.Mypackets.length > 0) {
          this.isShowpacket = 1;
          this.currentpacket = this.Mypackets[0];
        } else {
          this.$message("红包被抢完了");
        }
      },
      // 刷新红包列表
      async getRedpacket() {
        let result = await envelope({
          roomId: this.a.roomid,
        });

        if (result.data.code == 200 && result.data.message == "success") {
          let arr = result.data.data;
          this.Mypackets = arr;
          if (this.Mypackets.length > 0) {
            this.currentpacket = this.Mypackets[0];
            if (this.currentpacket.remainTime > 0) {
              clearInterval(interTime);
              this.lastTime(Number(this.currentpacket.remainTime))
            }
          }
        }
        console.log("红包列表", this.Mypackets);
      },
      clearmessage() {
        this.message = [];
        this.message1 = [];
        this.$message("清空成功");
      },
      navmore() {
        this.$NewRouter(`/v2/lives/all`);
        // const neww = this.$router.resolve({
        //   path: "/pageLive",
        //   query: {
        //     rid: 1,
        //     infoId: 1,
        //     valId: ''
        //   },
        // });
        // window.open(neww.href, "_self");
      },
      streams() {
        const that = this;
        // 获取数据流
        // 对应分类列表的数据流
        that.$axios
          .get(that.api + "/v2/list/streams", {
            params: {
              pcatId: 1,
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
            },
          })
          .then((res) => {
            //  console.log(res);
            if (res.data.message == "success") {
              let uid = this.broadcastingData.user.uid;
              let userData = JSON.parse(JSON.stringify(res.data.data));
              let datas = userData.list.filter((item) => item.user.uid !== uid);
              console.log(datas, uid, "数据1123");
              that.shouyeData.list = datas;
            }
          });
      },
      denglu() {
        this.$emit("emitLongin");
      },
      // 神龙跳转房间
      shenlongRouter(uid) {
        console.log('神龙礼物....................................................................', uid)
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: uid
          },
        });
        window.open(neww.href, "_self");
      },
      // 房间日榜单
      shuanxinpaihang() {
        this.$axios({
          url: this.api +
            "/v1/rank/room/contribution?uid=" +
            this.a.roomid +
            "&rankType=total",
          method: "GET",
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }).then((res) => {
          this.paihangbanData = res.data.data;
        });
      },
      // 用户关注主播
      guanzhuzhuobo() {
        if (localStorage.getItem("token")) {
          this.$axios({
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                return data;
              },
            ],
            url: this.api + "/v1/relation/follow",
            method: "post",
            data: {
              actionUid: this.a.roomid,
              nimFromAccid: this.nimparams.nimFromAccid,
              nimRoomId: this.nimparams.nimRoomId,
            },
          }).then((res) => {
            if (res.data.message == "success") {
              this.weiguanzhuZhubo = false;
              this.yiguanzhuZhubo = true;
              this.$message({
                message: "关注成功",
                type: "success",
              });
            } else {
              this.weiguanzhuZhubo = true;
              this.yiguanzhuZhubo = false;
            }
          });
        } else {
          this.denglu()
        }
      },
      // 用户取关主播
      quguanzhuobo() {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/unfollow",
          method: "post",
          data: {
            actionUid: this.a.roomid,
          },
        }).then((res) => {
          //   console.log(res);
          if (res.data.message == "success") {
            this.weiguanzhuZhubo = true;
            this.yiguanzhuZhubo = false;
            this.$message({
              message: "取关成功",
              type: "success",
            });
          } else {
            this.weiguanzhuZhubo = false;
            this.yiguanzhuZhubo = true;
          }
        });
      },
      changeDanmu(val) {
        if (val == 1) {
          this.barrageIsShow = false
        } else {
          this.barrageIsShow = true
        }
      },
      addToList() {
        if (this.barrageIsShow) {
          this.barrageList.push({
            id: new Date().getTime(),
            //   avatar: ".https://oss.ansongqiubo.com/static/avatar.jpg",
            msg: this.msg,
            time: 5,
            // type: MESSAGE_TYPE.NORMAL,
          });
        }
      },
      // 主播关播后跳转其他直播间
      Jinruzhibojian(id, flv) {
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: id
          },
        });
        window.open(neww.href, "_self");
      },
      // 主播关播跳转
      zhuboguanbo(id, flv) {
        // console.log(id);
        // console.log(flv);
      },
      // 分享的显示隐藏
      Fenxiang() {
        // this.reload()
        this.fenxiang = !this.fenxiang;
      },
      // 点击复制
      copys() {
        console.log(123666666666666666666666666666666666666);
        var clipboard = new Clipboard(".tag-read");
        const _this = this;
        clipboard.on("success", function(e) {
          _this.fenxiang = false;
          _this.$message({
            message: "复制成功",
            type: "success",
          });
        });
        clipboard.on("error", function(e) {
          _this.$message({
            message: "复制失败",
            type: "error",
          });
        });
      },
      // 跳转用户页面
      zhibojianAnchor(e) {
        console.log(e);
        // if(localStorage.getItem('toekn')){
        //   if (this.a.userid == e) {
        //     this.$router.push({
        //       path: "/gerenyemian"
        //     });
        //   } else {
        //     this.$router.push({
        //       path: "/yonghuyemian",
        //       query: {
        //         uid: e
        //       }
        //     });
        //   }
        // }
      },
      // 名片关注
      cardAttention(e) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/follow",
          method: "post",
          data: {
            actionUid: e,
          },
        }).then((res) => {
          // console.log(res);
          if (res.data.message == "success") {
            // 获取关注关系
            this.getcareList(e, 2)
          }
        });
      },
      // 名片取关
      cancelAttention(e) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/relation/unfollow",
          method: "post",
          data: {
            actionUid: e,
          },
        }).then((res) => {
          // console.log(res);
          if (res.data.message == "success") {
            // 获取关注关系
            this.getcareList(e, 2)
          }
        });
      },
      // 获取关注列表
      async getcareList(e, type = 1) {
        this.token = localStorage.getItem("token");
        if (this.token) {
          let list = await this.$store.dispatch('getUserFollowData', type);
          console.log('我的关注列表·', list);
          this.guanzhuListId = list;
          this.tracqAttentionRelation = 1;
          this.guanzhuListId.map(item => {
            if (item.uid == e) {
              this.tracqAttentionRelation = 2;
            }
          })
        }
      },
      // 名片设置管理员
      cardAdministrator(e) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/manage/room/add",
          method: "post",
          data: {
            roomId: this.a.roomid,
            uid: e,
          },
        }).then((res) => {
          this.TraCQ(e);
          this.Operation(e);
          console.log(res);
        });
      },
      // 名片解开管理员
      cardLoosenAdministrator(e) {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              return data;
            },
          ],
          url: this.api + "/v1/manage/room/remove",
          method: "post",
          data: {
            roomId: this.a.roomid,
            uid: e,
          },
        }).then((res) => {
          this.TraCQ(e);
          this.Operation(e);
          console.log("解开管理员" + res);
        });
      },
      // 名片禁言
      cardBanned(e) {
        // nimFromAccid:this.nimparams.nimFromAccid,
        // nimRoomId:this.nimparams.nimRoomId,
        usermute({
          roomId: this.a.roomid,
          uid: e,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }).then((res) => {
          if (res.data.message == "success") {
            this.Operation(e);
            this.$message({
              message: '禁言成功',
              type: 'success'
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        });
      },
      // 名片解禁
      cardLoosenBanned(e) {
        userunmute({
          roomId: this.a.roomid,
          uid: e,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }).then((res) => {
          console.log("解开禁言" + res);
          if (res.data.message == "success") {
            this.Operation(e);
            this.TraCQ(e);
            this.$message({
              message: '解禁成功',
              type: 'success'
            })
            setTimeout(() => {
              this.tracq = false;
            }, 2000)
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        });
      },
      // 15021103536
      // 超管封禁用户
      cardBan(uid) {
        userStartmute({
          uid: uid,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }).then((res) => {
          if (res.data.message == "success") {
            this.$message({
              message: '该用户已被封禁',
              type: 'success'
            })
            this.tracq = false;
            var _this = this;
            for (let index = 0; index < this.message.length; index++) {
              if (this.message[index].message.currentUser.uid == uid) {
                this.shanchuindex.push(index);
              } else {}
            }
            for (let i = 0; i < this.message1.length; i++) {
              if (this.message1[i].currentUser.uid == uid) {
                this.shanchuindex2.push(i);
              } else {}
            }
            var indexs = this.shanchuindex;
            indexs.sort(function(a, b) {
              return b - a;
            });
            indexs.forEach(function(index) {
              _this.message.splice(index, 1);
            });
            var indexs2 = this.shanchuindex2;
            indexs2.sort(function(a, b) {
              return b - a;
            });
            indexs2.forEach(function(index) {
              _this.message1.splice(index, 1);
            });
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        });
      },
      // 名片举报
      cardReport(e) {
        this.jubao = true;
        this.$nextTick(()=>{
          this.$refs.MyReport.setUids(e);
        })
      },
      // @TA
      cardTA(e, uid) {
        this.messageInput = "@" + e + " ";
      },
      // 时间戳
      dateFormat: function(time) {
        var times = time * 1000;
        var date = new Date(times);
        var year = date.getFullYear();
        var month =
          date.getMonth() + 1 < 10 ?
          "0" + (date.getMonth() + 1) :
          date.getMonth() + 1;
        var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var hours =
          date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var seconds =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        // 拼接
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds
        );
      },
      //历史推单界面
      getLishiTuidan() {
        if (localStorage.getItem("token")) {
          this.hitoryorderloading = '加载中···'
          let i = this.hitoryorderindex
          anchorRecommendList({
            anchorUserId: this.a.roomid,
            page: i,
            limit: 10
          }).then((res) => {
            console.log('历史推单', res.data);
            if (res.data.code == 200) {
              if (i == 1) {
                if (res.data.data && res.data.data.list.length > 0) {
                  this.tuidanlishi = res.data.data.list;
                  this.hitoryorderloading = '没有更多了'
                  this.hitoryorderindex++
                } else {
                  this.hitoryorderloading = '没有更多了'
                  this.tuidanlishi = []
                }
              } else {
                if (res.data.data && res.data.data.list.length > 0) {
                  this.tuidanlishi = this.tuidanlishi.concat(res.data.data.list);
                  this.hitoryorderindex++
                } else {
                  this.hitoryorderloading = '没有更多了'
                }
              }
            }
          });
        } else {
          // this.$message.error('请先登录后尝试')
        }
      },
      handleClose(done) {
        done();
      },
      // 推单的显示隐藏
      Tuidan() {
        this.tuidan = true;
      },
      TuidanGuanbi() {
        this.tuidan = false;
      },
      // 购买的显示隐藏
      Goumai() {
        this.goumai = true;
        this.tuidanIndex = 0;
      },
      GoumaiGuanbi() {
        this.goumai = false;
      },
      // 底部礼物详情的显示
      shubiaoyiru2(e) {
        this.liwuliebiao2Index = e;
      },
      shubiaoyichu2() {
        this.liwuliebiao2Index = null;
      },
      // 点击右边出现的礼物列表
      shubiaoyiru(e) {
        this.liwuliebiaoIndex = e;
      },
      shubiaoyichu(e) {
        this.liwuliebiaoIndex = null;
      },
      // 背包礼物点击
      Beibaoliwu() {
        this.haohualiwu = false;
        this.beibao = true;
      },
      // 拦截礼物
      lanjieLiwu(item){
        this.$message.error('该礼物需要粉丝团勋章'+item.level+'级，才能发送哦！')
      },
      // 赠送礼物接口
      ZengsongLiwu(e) {
        if (localStorage.getItem("token")) {
          if( this.nimparams.nimFromAccid){
            giftsend({
              roomId: this.a.roomid,
              giftId: e,
              num: 1,
              nimFromAccid: this.nimparams.nimFromAccid,
              nimRoomId: this.nimparams.nimRoomId,
            }).then((res) => {
              // console.log(res);
              if (res.data.message == "success") {
                this.liwuLiabiao = false;
                // 获取龙币余额
                this.getMoneys(2)
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'error'
                })

              }
              this.scorllTop();
            });
          }else{
            this.$message({
              message: '赠送失败',
              type: 'error'
            })
          }

        } else {
          this.denglu()
          this.$message({
            message: '请登录后操作',
            type: 'error'
          })
        }
      },
      // 获取用户卡片可操作动作
      Operation(uid) {
        this.$axios
          .get(this.api + "/v1/manage/user/operation", {
            params: {
              roomId: this.a.roomid,
              uid: uid,
            },
            headers: {
              device: "web",
              packageId: "1",
              version: "1.0.0",
              channel: "web",
              "authToken": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            this.quanxian = res.data.data;
            this.tracq = true;
          });
      },
      opneCardCQ() {

        console.log('打开名片');
      },
      // 点击name获取名片
      // 点击name获取名片
      TraCQ(uid) {
        if (!this.sendMessage) {
          this.denglu()
          return
        }

        if(this.a.userid == uid){
          console.log('自己不能点击自己');
          return
        }

        let objs = {
          roomId:this.a.roomid,
          uid:uid,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }

        console.log('我的名片数据',objs);
        this.$refs.myroledialog.open(objs)
        return
        //
        if (this.oneselfTracq == true || this.tracq == true) {
          console.log("已经打开名片");
        } else {
          // 用户信息接口
          this.$axios
            .get(this.api + "/v1/profile/user", {
              params: {
                uid: uid,
              },
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
              },
            })
            .then((res) => {
              // console.log(res);
              this.tracqXinxi = res.data.data;
            });

          if (this.a.userid == uid) {
            this.oneselfTracq = true;
          } else {
            this.Operation(uid);
            // console.log(123);
          }
        }
      },
      // 当直播间封停点击确定返回首页
      Top() {
        this.ban = false;
        this.$NewRouter('/v2')
        // this.router.push({
        //   path: "/"
        // });
      },
      // 鼠标移入聊天name换色
      NameYiru(e) {
        this.nameindex = e;
        // console.log(e);
      },
      NameYichu(e) {
        this.nameindex = null;
        // console.log(e);
      },
      // 礼物分类index
      LiwufenleiIndex(e) {
        this.liwufenleiindex = e;
        this.beibao = false;
        this.haohualiwu = true;
      },
      // 用户进入直播间行为
      into() {

        window.nimleavelive = {
          roomId: this.a.roomid,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }

        roomJoin({
          roomId: this.a.roomid,
          nimFromAccid: this.nimparams.nimFromAccid,
          nimRoomId: this.nimparams.nimRoomId,
        }).then((res) => {
          if(res.data.code == 200){
            console.log('加入直播间', res);
            if(res.data.data.globalMute){
              if(res.data.data.globalMute.remainTime !=0){
                // http://127.0.0.1:8085/roominfo?roomId=22028
                // 记录禁言的的状态及时间
                this.muteData = res.data.data.globalMute;
                this.FifshutData()
                this.liaotian =  false
              }
            }
            if(res.data.data.roomMute){
              if(res.data.data.roomMute.remainTime !=0){
                // http://127.0.0.1:8085/roominfo?roomId=22028
                // 记录禁言的的状态及时间
                this.muteData = res.data.data.roomMute;
                this.FifshutData()
                this.liaotian =  false
              }
            }
          }
        });
      },
      // 用户退出直播间行为
      quit() {

        // sessionStorage.setItem('nimparams',JSON.stringify({
        //   nimFromAccid: this.nimparams.nimFromAccid,
        //   nimRoomId: this.nimparams.nimRoomId,
        //   roomId: this.a.roomid,
        // }))
        // setroomleave({
        //   nimFromAccid: this.nimparams.nimFromAccid,
        //   nimRoomId: this.nimparams.nimRoomId,
        //   roomId: this.a.roomid,
        // })
        // this.$axios({
        //   headers: {
        //     device: "web",
        //     packageId: "1",
        //     version: "1.0.0",
        //     channel: "web",
        //     "authToken": localStorage.getItem("token"),
        //     "Content-Type": "application/x-www-form-urlencoded",
        //   },
        //   transformRequest: [
        //     function(data) {
        //       //在请求之前对data传参进行格式转换
        //       data = qs.stringify(data);
        //       return data;
        //     },
        //   ],
        //   url: this.api + "/v1/room/leave",
        //   method: "post",
        //   data: {
        //     nimFromAccid: this.nimparams.nimFromAccid,
        //     nimRoomId: this.nimparams.nimRoomId,
        //     roomId: this.a.roomid,
        //   },
        // }).then((res) => {
        //   //   console.log(res);
        // });
      },
      // 直播间的socket
      lianjie: function() {
        if (typeof WebSocket === "undefined") {
          this.$message({
            message: '您的浏览器不支持socket',
            type: 'error'
          })
          // console.log(123);
        } else {
          // 实例化socket
          this.socket = new WebSocket(
            this.ws +
            "?product=lz&module=chat&roomid=" +
            this.a.roomid +
            "&userid=" +
            this.a.userid +
            "&accessToken=" +
            this.accessToken
          );
          // console.log(this.socket);
          // 监听socket连接
          this.socket.onopen = this.open;
          // 监听socket错误信息
          this.socket.onerror = this.error;
          // 监听socket消息
          this.socket.onmessage = (result) => {
            var message = JSON.parse(result.data);
            console.log('socket版本：', message.version);
            if (!message.version || message.version < 2) {
              this.getMessage(message);
            }

            // let list = [10408 ,10407,10406,10405,10404,10403,10402,10401,10006 ];
            // var message = JSON.parse(result.data);
            // let status = list.some(item=>item == message.messageType);
            // if(status){
            //   console.log('触发了之前的socket');
            //   this.getMessage(message);
            // }
          }
          this.socket.onclose = this.close;
        }
      },
      open: function(e) {
        console.log("直播间socket连接成功");
        this.socketIndex = 5;
        this.heartCheck();
      },
      close(e) {
        // console.log(e);
        if (this.socketIndex > 0) {
          console.log("直播间socket 重新连接close", this.socketIndex);
          setTimeout(() => {
            if (this.socket) this.socket.close();
            this.socket = null
            // this.lianjie();
            this.socketIndex = this.socketIndex - 1
          }, 100);
        } else {
          if (this.socket) this.socket.close();
          // this.$message({
          //   message: '直播间消息连接失败',
          //   type: 'error'
          // })
        }
      },
      error(e) {
        // console.log(e);
        if (this.socketIndex > 0) {
          console.log("直播间socket 重新连接error", this.socketIndex);
          setTimeout(() => {
            if (this.socket) this.socket.close();
            this.socket = null
            // this.lianjie();
            this.socketIndex = this.socketIndex - 1
          }, 100);
        } else {
          if (this.socket) this.socket.close();
          // this.$message({
          //   message: '直播间消息连接失败',
          //   type: 'error'
          // })
        }
      },
      // 心跳机制
      heartCheck() {
        let timeout = 3000; //5秒，针对不同项目设置不同时间，比如客服系统就不用那么频繁检测，股票交易所就必须很频繁
        clearTimeout(this.timeoutObj);
        // clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(() => {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          this.socket.send(JSON.stringify({
            "function": "heart"
          })); //发送这个消息的时候，必须让后端收到消息后，立马发送一个消息，这样来回一个接收过程，就可以判断当前还没有断开连接。
          // self.serverTimeoutObj = setTimeout(function() { //如果超过一定时间还没重置，说明后端主动断开了
          //     console.log('%c [ 主动断开了 ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;', '主动断开了')
          //     myselft.socket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          // },2000)
        }, timeout)
      },
      // ws推过来的信息
      getMessage: function(message) {
        // this.heartCheck();
        console.log('消息监听', message)

        if(this.message.length > 100){
          this.message.shift()
        }


        if (message.messageType === 10001) {
          console.log('用户发言', message)
          var yanse = [{
              color: "linear-gradient(270deg, #7726DD 0%, #721EDC 100%);",
            },
            {
              color: "linear-gradient(270deg, #00B6FF 0%, #6B00FF 100%)",
            },
            {
              color: "linear-gradient(270deg, #FFCC32 0%, #FF9500 100%)",
            },
          ];

          this.xiaoxiduilie.push(message);
          this.message.push(message);
          for (let index = 0; index < this.xiaoxiduilie.length; index++) {
            this.xiaoxishuju = this.xiaoxiduilie[index];
            this.$nextTick(() => {
              if (this.$refs.jinchangdonghua) {
                // this.$refs.jinchangdonghua.style.background = yanse[0];
                this.$refs.jinchangdonghua.style.left = "10px";
                this.$refs.jinchangdonghua.style.transition = "1s";
                this.$refs.jinchangdonghua.style.opacity = "1";
                setTimeout(() => {
                  this.$refs.jinchangdonghua.style.left = "-490px";
                  this.$refs.jinchangdonghua.style.transition = "0.1s";
                  this.$refs.jinchangdonghua.style.opacity = "0";
                }, 3000);
              }
            });
            this.xiaoxiduilie.splice(0, 1);
          }
          if (this.yanseindex < 2) {
            this.yanseindex = this.yanseindex++;
          } else {
            this.yanseindex = 0;
          }
          // 用户进入直播间
          this.scorllTop();

          // // 刷新直播间信息
          // this.$axios({
          //   url: this.api + "/v1/room/info?uid=" + this.a.roomid,
          //   method: "GET",
          //   headers: {
          //     device: "web",
          //     packageId: "1",
          //     version: "1.0.0",
          //     channel: "web",
          //     "Content-Type": "application/json",
          //   },
          // }).then((res) => {
          //   if (res.data.code == 200) {
          //     console.log('获取直播间信息1',res);
          //     this.broadcastingData = res.data.data;
          //   }
          // });

          // console.log("进入直播间");
        } else if (message.messageType === 10002) {
          // 刷新直播间信息
          // this.$axios({
          //   url: this.api + "/v1/room/info?uid=" + this.a.roomid,
          //   method: "GET",
          //   headers: {
          //     device: "web",
          //     packageId: "1",
          //     version: "1.0.0",
          //     channel: "web",
          //     "Content-Type": "application/json",
          //   },
          // }).then((res) => {
          //   console.log('获取直播间信息2',res);
          //   this.broadcastingData = res.data.data;
          // });
          // 用户离开直播间
          // console.log("离开直播间");
        } else if (message.messageType === 10003) {
          console.log('新消息来袭', this.a.userid, message.message.currentUser.uid)
          // 用户直播间发消息
          // 未登录不显示弹幕消息
          this.message.push(message);
          let barrageStyle = ''
          // 判断是不是自己的弹幕
          if (this.a.userid == message.message.currentUser.uid) {
            barrageStyle = 'mybarrage1'
          } else {
            barrageStyle = 'mybarrage'
          }
          if (this.barrageIsShow) {
            this.barrageList.push({
              id: ++this.currentId,
              // avatar: message.message.currentUser.avatar,
              msg: message.message.currentUser.nickname +
                ":" +
                message.message.message.content,
              time: 16,
              barrageStyle: barrageStyle,
              // type: MESSAGE_TYPE.NORMAL,
            });
          }
          this.scorllTop();
        } else if (message.messageType === 10004) {

          this.message.push(message);
          this.getUserInfoData()
          this.liwuData = message;
          // 刷新排行榜
          this.shuanxinpaihang();
          this.liwudonghuaduilie.push(message);
          console.log(
            "%c [ 礼物 ]: ",
            "color: #bf2c9f; background: pink; font-size: 13px;",
            this.liwudonghuaduilie
          );
          setTimeout(() => {
            this.Liwuduilie();
          }, 200);
          this.messagesss.push({
            animation: message.message.gift.webScreeIcon,
            status: false,
          });
          if (message.message.gift.webScreeIcon == "") {
            // console.log("没有礼物特效");
          } else {


            let giftId = message.message.gift.giftId;
            let bailist = [48, 31, 35, 93, 59, ]

            // 过滤----全局飘窗礼物
            let status = bailist.some(item => item == giftId);
            if (!status) {
              console.log('过滤掉了吗', status);
              var player = new SVGA.Player("#svga");
              var parser = new SVGA.Parser("#svga");
              //注意，这里必须是服务器地址，否则报错
              this.messagesss.map(async (item) => {
                if (item.status == false) {
                  await new Promise((resolve, reject) => {
                    item.status = true;
                    // 用户发送礼物信息
                    this.$nextTick(() => {
                      this.changesvga = true;
                    });
                    setTimeout(
                      parser.load(item.animation, (videoItem) => {
                        player.loops = 1;
                        player.setVideoItem(videoItem);
                        player.startAnimation();
                        resolve(true);
                        this.changesvga = true;
                      }),
                      5000
                    );
                  });
                }
              });
            }

          }
          this.scorllTop();
        } else if (message.messageType === 10005) {
          let {
            room: {
              heatValue
            },
            online: {
              count
            }
          } = message.message.roomInfo;

          this.broadcastingData.room.heatValue = heatValue;
          this.broadcastingData.online.count = count
          console.log('当前热度', heatValue, count,this.broadcastingData);
          //
        } else if (message.messageType === 10401) {
          this.tuidanmessage = message;
          console.log('推单消息', this.tuidanmessage);
          // 什么时候推
          this.message.push(message);
          // 用户进入直播间
          this.$nextTick(() => {
            this.scorllTop();
          })
        } else if (message.messageType === 10007) {
          let copyMsg = JSON.parse(JSON.stringify(this.message));
          let historyArr = JSON.parse(JSON.stringify(this.message1));
          let newMSG = [],
            hisMsg = [];
          console.log('用户禁言消息', message, '消息总列表', copyMsg, historyArr);
          historyArr.map(items => {
            if (items.currentUser && items.currentUser.uid != message.message.targetUser.uid) {
              hisMsg.push(items)
            }
          })
          copyMsg.map((items) => {
            if (items.baseInfo.sendUid != message.message.targetUser.uid) {
              newMSG.push(items)
            }
          })
          this.message = newMSG;
          this.message1 = hisMsg;
          this.message.push(message);
          console.log('数据消息列表', this.message, this.message1)


          // 只禁言当前直播间
          // if()
            console.error('全局禁言消息',this.a.userid, message.message);
            if(this.a.userid == message.message.targetUser.uid){
              this.muteData = message.message.limitDetail;
              if(message.message.limitDetail && message.message.limitDetail.expireTime > 0  ){
                // // 记录禁言的的状态及时间
                this.FifshutData()
              }
              this.liaotian =  false
          }
          this.$forceUpdate()
        } else if (message.messageType === 10018) {


          if(this.a.userid == message.message.targetUid){
            console.log('解除禁言通知',message);
              this.$message.success('已解除您的禁言')
              this.liaotian = true;
              clearTimeout(this.shutTimes)
          }

          // 解除禁言通报
          // if(this.a.userid == message.message.targetUser.uid){

          // }
        } else if (message.messageType === 10008) {
          // console.log(message);
          // alert("主播关播了")
          this.OverLiveAtreaming = true;
        } else if (message.messageType === 10009) {
          // console.log(message);
          // alert("主播关播了")
          this.closeVideLives = true;
          this.closeVideLiveData = message.message;
          // // 记录禁言的的状态及时间
          this.FifshutData2()
        } else if (message.messageType === 10010) { //  后台封禁用户
          console.log('当前用户的uid', this.a.userid, '被封禁的uid', message, message.message.currentUser.uid);
          if (this.a.userid == message.message.currentUser.uid) {
            if(message.message.limitDetail.expireTime >0){
              let time = ''
              if(message.message.limitDetail.remainTime > 3600){
                time  = moment('2020-11-16','YYYY-MM-DD').add(message.message.limitDetail.remainTime, 'second').format('HH:mm:ss');
              }else{
                time  = moment('2020-11-16','YYYY-MM-DD').add(message.message.limitDetail.remainTime, 'second').format('mm:ss');
              }
              this.$message.success(`您涉嫌${this.FifmuteData(message.message.limitDetail.reason)}已被封禁,解除时间为${time}s`)
            }else{
              this.$message.success(`您涉嫌${this.FifmuteData(message.message.limitDetail.reason)}已被永久封禁`)
            }
            console.log('用户已经封禁',message.message)
            setTimeout(()=>{
              // this.$router.replace('/')

              localStorage.clear()
              location.href = '/v2'
            },800)
          } else {
            if (this.Twitterlist) {
              this.$message({
                message: '该用户已被封禁',
                type: 'success'
              })
            }
            let copyMsg = JSON.parse(JSON.stringify(this.message));
            let historyArr = JSON.parse(JSON.stringify(this.message1));
            let newMSG = [],
              hisMsg = [];
            console.log('用户禁言消息', message, '消息总列表', copyMsg, historyArr);
            historyArr.map(items => {
              if (items.currentUser && items.currentUser.uid != message.message.currentUser.uid) {
                hisMsg.push(items)
              }
            })
            copyMsg.map((items) => {
              if (items.baseInfo.sendUid != message.message.currentUser.uid) {
                newMSG.push(items)
              }
            })
            this.message = newMSG
            this.message1 = hisMsg
            this.tracq = false;
            this.message.push(message);
            console.log('封禁后数据', this.message1)
          }
        } else if (message.messageType === 10016 || message.messageType === 10017) {
          // 红包来了
          this.getRedpacket();
          console.log('红包来了。。。。。。。。。。。。。。。。。。。。。。');
        } else if (message.messageType === 10405) {
          this.message.push(message);
          this.scorllTop();
        } else if (message.messageType === 10406) {
          this.message.push(message);
          this.scorllTop();
        } else if (message.messageType === 10403) {
          // 封单解封
          this.getrecommendDetail(message.message.recommendId, 10403);
          // 用户进入直播间
          this.$nextTick(() => {
            this.scorllTop();
          })
        } else if (message.messageType === 10402) {
          // 封单解封
          this.getrecommendDetail(message.message.recommendId, 10402);
          // 用户进入直播间
          this.$nextTick(() => {
            this.scorllTop();
          })
        } else if (message.messageType == 10013) {
          this.message.push(message);
          this.scorllTop();
          // 关联比赛结束状态的推送(针对主播端)
        } else if (message.messageType == 10407) {
          console.log(' 关联比赛结束状态的推送(针对用户端', message, this.matchId);
          // if(this.matchId == message.message.matchId){
          this.changeAlert()
          // }
          //  主播关联比赛的推送(针对用户端)
        } else if (message.messageType == 10408) {
          let sendUid = message.baseInfo.sendUid;
          if (sendUid == this.a.roomid) {
            this.matchId = message.message.matchId;
          }

          // 990
          // 48 64133

          console.log(' 主播关联比赛的推送(针对用户端)', message, this.matchId);
          // this.getScope()
        }else if (message.messageType == 10410 ) {
          console.log('主播任务推送', message);
          this.AnchorTaskList = message.message
          // this.message.push(message);
        } else if (message.messageType == 11111) {
          console.log('自定义系统消息', message);
          this.message.push(message);
        }
      },
      getUserInfoData() {
        // 刷新直播间信息
        roomInfo({
          uid: this.a.roomid,
          virtualId:this.virtualId,
          versionCode:110,
        }).then((res) => {
          console.log('获取直播间信息', res);
          if(res.data.code == 200){
            this.broadcastingData = res.data.data;
          }else{
            console.error(res.data.message);
          }
        });
      },
      // 进场动画队列
      Liwuduilie() {
        // console.log(this.liwudonghuaduilie);
        this.$nextTick(() => {
          this.$refs.liwudonghua2.style.transition = "2s";
          this.$refs.liwudonghua2.style.opacity = "1";
          this.$refs.liwudonghua2.style.bottom = "150px";
          setTimeout(() => {
            this.$refs.liwudonghua2.style.bottom = "350px";
            this.$refs.liwudonghua2.style.opacity = "0";
            this.$refs.liwudonghua2.style.transition = "3s";
          }, 3000);
          setTimeout(() => {
            this.liwuData = [];
          }, 4000);
        });
      },

      // 全局socket
      lianjie2: function() {
        this.globalWs.roomid = this.$route.query.roomId; // 房间id
        this.globalWs.userid = this.a.userid;
        // ASSCI码升序排序
        var arr2 = new Array();
        var num2 = 0;
        for (var i in this.globalWs) {
          arr2[num2] = i;
          num2++;
        }
        var sortArr2 = arr2.sort();
        var sortObj2 = {};
        for (var i in sortArr2) {
          sortObj2[sortArr2[i]] = this.globalWs[sortArr2[i]];
        }
        // 接口拼接
        // console.log(sortArr2);
        var assci2 =
          sortArr2[0] +
          "=global" +
          "&" +
          sortArr2[1] +
          "=lz" +
          "&" +
          sortArr2[2] +
          "=0" +
          "&" +
          sortArr2[3] +
          "=" +
          this.globalWs.userid +
          "&" +
          "salt=12345";
        // console.log(assci2);
        // md5加密
        this.accessToken2 = this.$md5(assci2);
        // console.log(this.accessToken2);
        if (typeof WebSocket === "undefined") {
          this.$message({
            message: '您的浏览器不支持socket',
            type: 'error'
          })
          // console.log(123);
        } else {
          // 实例化socket
          this.socket2 = new WebSocket(
            this.ws +
            "?product=lz&module=global&roomid=0" +
            "&userid=" +
            this.globalWs.userid +
            "&accessToken=" +
            this.accessToken2
          );
          // console.log(this.socket);
          // 监听socket连接
          this.socket2.onopen = this.open2;
          // 监听socket错误信息
          this.socket2.onerror = this.error2;
          // 监听socket消息
          this.socket2.onmessage = this.getMessage2;
          this.socket2.onclose = this.close2;
        }
      },
      // 心跳机制
      heartCheck2() {
        let timeout = 2000; //5秒，针对不同项目设置不同时间，比如客服系统就不用那么频繁检测，股票交易所就必须很频繁
        clearTimeout(this.globalTime);
        // clearTimeout(this.serverTimeoutObj);
        this.globalTime = setTimeout(() => {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          //onmessage拿到返回的心跳就说明连接正常
          this.socket2.send(JSON.stringify({
            "function": "heart"
          })); //发送这个消息的时候，必须让后端收到消息后，立马发送一个消息，这样来回一个接收过程，就可以判断当前还没有断开连接。
          // self.serverTimeoutObj = setTimeout(function() { //如果超过一定时间还没重置，说明后端主动断开了
          //     console.log('%c [ 主动断开了 ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;', '主动断开了')
          //     myselft.socket.close(); //如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
          // },2000)
        }, timeout)
      },
      open2: function(e) {
        console.log("全局socket连接成功");
        this.heartCheck2()
        // this.socketIndex2 = 5;
      },
      close2(e) {
        if (this.socketIndex2 > 0) {
          console.log("全局socket 重新连接", this.socketIndex2);
          setTimeout(() => {
            // if(this.socket2)this.socket2.close();
            this.socket2 = null
            this.lianjie2();
            this.socketIndex2 = this.socketIndex2 - 1
          }, 500);
        } else {
          console.log("全局ws关闭");
          // if(this.socket2)this.socket2.close();
          // this.$message({
          //   message: '连接已断开，请刷新浏览器重试！',
          //   type: 'error'
          // })
        }
      },
      error2(e) {
        if (this.socketIndex2 > 0) {
          console.log("全局socket 重新连接", this.socketIndex2);
          setTimeout(() => {
            // if(this.socket2)this.socket2.close();
            this.socket2 = null
            this.lianjie2();
            this.socketIndex2 = this.socketIndex2 - 1
          }, 500);
        } else {
          console.log("全局ws关闭");
          if (this.socket2) this.socket2.close();
          // this.$message({
          //   message: '连接已断开，请刷新浏览器重试！',
          //   type: 'error'
          // })
        }
      },
      // 处理礼物队列
      useGifCuuent() {
        if (this.shenlongCurrentDataList.length > 0 && this.shenlongstatus) {
          if (this.shenlongIndex < this.shenlongCurrentDataList.length) {
            var player = new SVGA.Player("#svga");
            var parser = new SVGA.Parser("#svga");
            this.shenlongData = this.shenlongCurrentDataList[this.shenlongIndex];
            console.log('消费', this.shenlongData);
            this.shenlongstatus = false;
            this.$nextTick(() => {
              setTimeout(() => {
                this.piaochuangclass = "shenlongStyleLeft";
              }, 500)
              // 不是本直播间不显示
              let roomgiftId = this.shenlongData.message.targetUser.uid;
              if (roomgiftId == this.a.roomid) {
                this.changesvga = true
                //注意，这里必须是服务器地址，否则报错
                parser.load(this.shenlongData.message.gift.webScreeIcon, function(videoItem) {
                  player.loops = 1;
                  player.setVideoItem(videoItem);
                  player.startAnimation();
                })
              }
              setTimeout(() => {
                this.piaochuangclass = "shenlongStyleRight";
                setTimeout(() => {
                  this.shenlongstatus = true;
                  this.shenlongIndex++;
                  this.changesvga = false
                  this.piaochuangclass = "shenlonghidden";
                  this.useGifCuuent()
                }, 1000)
              }, 7000);
            });
          } else {
            this.shenlongCurrentDataList = [];
            this.shenlongIndex = 0;
            this.useGifCuuent()
          }
        } else {
          if (this.shenlongDataList.length > 0) {
            if (this.shenlongCurrentDataList.length == 0) {
              this.shenlongIndex = 0
              this.shenlongCurrentDataList = this.shenlongDataList.splice(0, this.shenlongDataList.length);
              if (this.shenlongCurrentDataList.length > 0) {
                this.shenlongstatus = true;
              }
              this.useGifCuuent()
              console.log('尝试获取礼物数据', this.shenlongCurrentDataList);
              return
            } else {
              console.log('礼物还有呢', this.shenlongDataList.length);
              return
            }
          }
          console.log('没有礼物了', this.shenlongDataList);
        }


      },
      // ws推过来的信息
      getMessage2: function(msg) {
        var message = JSON.parse(msg.data);
        console.log("getMessage2 全局 消息", message);
        this.heartCheck2()
        if (message.messageType == 10011) {
          this.shenlongDataList.push(message)
          // this.shenlongCurrentDataList = this.shenlongDataList;
          this.useGifCuuent()
        } else if (message.messageType == 10015) {
          this.shenlongData = message;
          if (this.shenlongData.message.type == "goldGuard") {
            this.piaochuangclass = "jinStyle";
          } else if (this.shenlongData.message.type == "silverGuard") {
            console.log("银色");
            this.piaochuangclass = "yinStyle";
          }
          this.$nextTick(() => {
            this.shenlongicon = false;
            this.$refs.shenlong.style.transition = "1s";
            this.$refs.shenlong.style.left = "0px";
            setTimeout(() => {
              this.$refs.shenlong.style.left = "-780px";
              this.$refs.shenlong.style.transition = "1s";
            }, 5000);
          });
        }
      },
      sendMessageHidden() {
        this.jinyan = true;
        setTimeout(() => {
          this.jinyan = false;
          this.sendmsgStatus = true;
        }, 2000);
      },
      // 发送信息接口
      async send() {
        console.log('点击了一次');
        if (localStorage.getItem("token")) {
          if(!this.nimparams.nimFromAccid){
            this.$message('发送失败')
            return
          }

          if (!this.sendmsgStatus) {
            this.jinyanCentent = '请稍后发送'
            this.sendMessageHidden()
            return
          }
          let keyWord = await this.$store.dispatch('fifWord', {
            key: "roomSendlist",
            value: this.messageInput
          })
          if (keyWord.state) {
            this.messageInput = keyWord.value;
          } else {
            this.messageInput = '';
            return
          }
          if (this.messageInput == '') {
            this.jinyanCentent = '发送内容不能为空'
            this.sendMessageHidden()
            return
          }
          this.messageInput =  this.messageInput.replace(/\ +/g, '').replace(/[\r\n]/g, '')
          console.log('发送消息', this.nimparams);
          this.sendmsgStatus = false;
          roomsendMsg({
            roomId: this.a.roomid,
            message: this.messageInput ? this.messageInput.trim() : "",
            nimFromAccid: this.nimparams.nimFromAccid,
            nimRoomId: this.nimparams.nimRoomId,
          }).then((res) => {
            if (res.data.code == 200) {
              this.sendmsgStatus = true;
            } else {
              this.jinyanCentent = res.data.message;
              this.sendMessageHidden()
            }
            this.messageInput = "";
          });
        } else {
          this.denglu()
          this.$message({
            message: '请登录后操作',
            type: 'error'
          })
        }
      },
      scorllTop() {
        this.$nextTick(() => {
          document.querySelectorAll(
            ".broadcast-right-bottom-message"
          )[0].scrollTop = document.querySelectorAll(
            ".broadcast-right-bottom-message"
          )[0].scrollHeight;
        });
      },
      sends(e) {
        var keyCode = window.event ? e.keyCode : e.which;
        // var val = e.target.value;
        if (keyCode == 13) {
          if (this.messageInput) {
            // console.log(this.messageInput);
            this.$axios({
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
                "Content-Type": "application/x-www-form-urlencoded",
              },
              transformRequest: [
                function(data) {
                  //在请求之前对data传参进行格式转换
                  data = qs.stringify(data);
                  return data;
                },
              ],
              url: this.api + "/v1/room/sendMsg",
              method: "post",
              data: {
                roomId: this.a.roomid,
                message: this.messageInput,
              },
            }).then((res) => {
              this.messageInput = "";
              //   console.log(res);
            });
          } else {
            console.log("请输入内容");
            this.scorllTop();
          }
        }
      },

      // 举报---------------------
      Jubao(e) {
        if (localStorage.getItem('token')) {
          this.jubao = true;
         this.$nextTick(()=>{
           this.$refs.MyReport.setUids(e);
         })
        } else {
          this.denglu()
        }
      },
      jubaos(e) {
        this.jubao = e;
      },
      //礼物滑动--------------------
      Right(val) {
        // if (this.liwu == -3168) {
        //     return
        // }else{
        //     this.liwu = this.liwu-528
        // }
        this.liwuLiabiao = !this.liwuLiabiao;
        if (val) {
          this.LiwufenleiIndex(3)
        } else {
          this.LiwufenleiIndex(0)

        }
        // console.log(this.liwu);
      },
      Left() {
        if (this.liwu == 0) {
          return;
        } else {
          this.liwu = this.liwu + 528;
        }
        // console.log(this.liwu);
      },
      // Right1(){
      //     if (this.liwu1 == -3136) {
      //         return
      //     }else{
      //         this.liwu1 = this.liwu1-448
      //     }
      //     console.log(this.liwu1);
      // },
      // Left1(){
      //     if (this.liwu1 == 0) {
      //         return
      //     }else{
      //         this.liwu1 = this.liwu1+448
      //     }
      //     console.log(this.liwu1);
      // },
      ZhuboTuidan() {
        this.zhubopush = true;
        // window._czc.push(['A0200', contentUrl, refererUrl])
      },
      GuanbiZhuboTuidan() {
        this.zhubopush = false;
      },
      // 直播播放器------------------
      init(source, isLive, title) {
        // console.log(source,isLive)
        this.isLive = isLive;
        this.visitable = true;
        this.title = title;
        //   console.log(source);
        if (this.source == "") {
          this.source = source;
        } else {
          this.$nextTick(() => {
            if (this.$refs.player) this.$refs.player.play();
          });
        }
      },
      //播放
      play(event) {
        console.log("播放", event);
      },
      //暂停
      pause(event) {
        //   console.log(event);
      },
      //直播出错恢复处理
      onM3u8Retry(event) {
        alert("主播暂时离开，请稍后......");
        this.closePlayer();
        this.visitable = false;
      },
      cancelFullScreen() {
        console.log("取消全屏");
      },
      requestFullScreen() {
        console.log("打开全屏，111111111111111");
      },
      liveStreamStop(event) {
        // console.log(event);
        //   alert('直播失败或直播已结束');
        this.closePlayer();
        this.visitable = false;
        // player.loadByUrl(newUrl);
      },
      //关闭模态层
      closePlayer() {
        this.$nextTick(() => {
          this.$refs.player.pause();
        });
      },
    },
    components: {
      Report,
      "ali-player": aliplayer,AnchorTask,
      roledialog,
      activedialog,
      roombarrage,
      receivetask,
      topPack,
      noticeItem,
      chatlabel,
      liveItem,
      roomScope
    },
    beforeDestroy() {
      console.log('退出聊天室');
      try {
        if (this.NIMROOM) {
          console.log('退出聊天室');
          this.quit()
          this.NIMROOM.disconnect()
        }
        if (this.socket) this.socket.close();
        // if( this.socket2) this.socket2.close();
        if (this.$refs.player) this.$refs.player.pause();
        console.log('关闭socket成功21');
        clearInterval(interTime);
      } catch (e) {
        console.log('关闭socket失败');
      }
    },
    destroyed() {
      window.removeEventListener("popstate", this.AddList, false);
      console.log('关闭socket成功2');
      if (this.$refs.player) this.$refs.player.pause();
      if (this.socket) this.socket.close();
      // if( this.socket2) this.socket2.close();
      console.log('关闭socket成功2');
    },
  }
</script>
<style scoped lang='scss'>
  @import "../assets/style/index.scss";
  @import "../assets/style/room.scss";

  @keyframes shananimal
  {
    0%   {
       transform: rotate(0);
    }
    30%   {
       transform: rotate(0);
    }
     45%   {
        transform: rotate(0);
        transition: all .2s;
     }
     50% {
       transform: rotate(20deg) scale(1.02);
       transition: all .2s;
     }
     52% {
       transform: rotate(-20deg) scale(1.06);
       transition: all .2s;
     }
     60% {
       transition: all .2s;
       transform: rotate(0);
     }
     70% {
       transform: rotate(0);
     }
     100% {
       transform: rotate(0);
     }
  }
  .Toppacket{
    position: absolute;
    z-index: 999;
    top: 16px;
    left: 16px;
    .myTopImg{
      width: 58px;
      height: 60px;
      animation:shananimal 3s infinite;
    }
  }

  .broadcast-right-bottom-input {
    overflow: hidden;
    margin: 0 12px;
    /deep/ .el-textarea__inner {
      border: none;
      outline-style: none;
      font-size: 12px;
      &::placeholder {
        line-height: 34px;
        color: #909399;
        font-size: 12px;
      }
    }
    .myinput {
      height: 46px;
      font-size: 12px;
      color: red;
    }
  }

  .prism-player .prism-big-play-btn .outter {
    z-index: 100 !important;
  }


  .prism-player .prism-ErrorMessage {
    z-index: 0 !important;
    /* background-color: #222222 !important; */
  }

  .prism-player .prism-controlbar {
    z-index: 0 !important;
  }

  .jubaoinput .el-textarea__inner {
    background-color: #747474 !important;
    border: #747474 solid 1px;
    height: 100% !important;
    min-height: 380px;
    max-height: 380px;
  }

  .jubaoinput>textarea {
    min-height: 90px !important;
  }

  .jubaoinput .el-textarea .el-input__count {
    background-color: #747474 !important;
    border: none;
    outline-style: none;
    color: white;
  }

  .xuanze .el-radio__input.is-checked+.el-radio__label {
    color: #dddddd;
  }

  .xuanze .el-radio {
    color: #a6a6a6;
  }

  .details-top-right-center2 .prism-player .prism-info-display {
    z-index: -1;
  }

  .details-top-right-center2 .prism-player .prism-loading {
    z-index: -1;
  }

  .details-top-right-center2 .prism-player .prism-ErrorMessage {
    z-index: 9;
  }

  .details-top-right-center2 .prism-player .prism-controlbar {
    z-index: 9;
  }


  @media screen and (max-width: 1450px)  {
     .redpackets{
       .hiddenGifts:nth-child(n+5){
         display: none !important;
       }
     }
  }
  @media screen   and (min-width:2500px) and (max-width: 2800px )  {
    .home-right-bottom{
      /* background-color: #000; */
      .setWidth{
          width: calc((100vw - 616px) / 6) !important;
      }
     /deep/ .home-right-li{
         width: calc((100vw - 672px ) / 6 ) !important;
         height: 238px;
         .home-right-info,.el-image img,.image-slot{
          width: calc((100vw - 672px ) / 6 ) !important;
         }
         .el-image img{
           height: 100% !important;
         }
       }
      /deep/ .setWidth:nth-child(n+13){
         display: none !important;
       }
    }

  }
  @media screen   and (min-width:2200px) and (max-width: 2500px )  {
    .home-right-bottom{
      /* background-color: #55ffff; */
      .setWidth{
          width: calc((100vw - 616px) / 5) !important;
      }
     /deep/ .home-right-li{
         width: calc((100vw - 672px ) / 5 ) !important;
         height: 238px;
         .home-right-info{
            object-fit:cover;
            width: calc((100vw - 672px ) / 5 ) !important;
         }
         .el-image img{
           height: 100% !important;
           width: calc((100vw - 672px ) / 5 ) !important;
         }
       }
       /deep/ .setWidth:nth-child(n+11){
          display: none !important;
        }
    }

  }
  @media screen   and (min-width:1800px) and (max-width: 2200px )  {
    .home-right-bottom{
      /* background-color: #55ff00; */
      .setWidth{
          width: calc((100vw - 616px) / 4) !important;
      }
     /deep/ .home-right-li{
         width: calc((100vw - 672px ) / 4 ) !important;
         height: 238px;
         .home-right-info,.el-image img{
          object-fit:cover;
          width: calc((100vw - 672px ) / 4 ) !important;
         }
         .el-image img{
           height: 100% !important;
         }
       }
    }
    /deep/ .setWidth:nth-child(n+9){
         display: none !important;
       }
  }
  @media screen   and (min-width:1400px) and (max-width: 1800px )  {
    .home-right-bottom{
      /* background-color: #ff0000; */
      .setWidth{
          width: calc((100vw - 616px) / 4) !important;
      }
     /deep/ .home-right-li{
         width: calc((100vw - 672px ) / 4 ) !important;
         height: 238px;
         .home-right-info,.el-image img{
          object-fit:cover;
          width: calc((100vw - 672px ) / 4 ) !important;
         }
         .el-image img{
           height: 100% !important;
         }
       }
    }
    /deep/ .setWidth:nth-child(n+9){
         display: none !important;
       }
  }
  @media screen   and (min-width:1000px) and (max-width: 1400px )  {
    .home-right-bottom{
      /* background-color: #ff0000; */
      .setWidth{
          width: calc((100vw - 616px) / 3) !important;
      }
     /deep/ .home-right-li{
         width: calc((100vw - 672px ) / 3 ) !important;
         height: 238px;
         .home-right-info,.el-image img{
          object-fit:cover;
          width: calc((100vw - 672px ) / 3) !important;
         }
         .el-image img{
           height: 100% !important;
         }
       }
    /deep/ .setWidth:nth-child(n+7){
         display: none !important;
       }
    }

  }
</style>



// WEBPACK FOOTER //
// src/component/BroadcastComponent.vue